const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN.toUpperCase()

export default {
	//login home page
	loginHeader: {
		contactUs: 'Contato conosco',
	},
	loginPage: {
		instructionstitle1: 'Estamos protegendo você!',
		instructionstitle2: 'Soluções para cada',
		instructionstitle3: 'preciso que você tenha',
		options1f: 'Acesse seu',
		options1l: 'Gabinete',
		options2f: 'Insira o seu',
		options2l: 'Portal do IB',
		options3f: 'Estude seus ',
		options3l: 'Relatórios de Propostas',
		termsAndConditions: 'Termos e condições',
		privacyPolicy: 'Política de Privacidade',
		amlPolicy: 'Política de AML',
		refundPolicy: 'Política de Reembolso',
		riskDisclosure: 'Divulgação de riscos',
		complaintsProcedure: 'Procedimento de reclamações',
		cookiePolicy: 'Política de Cookies',
		userError: 'A senha inserida está incorreta, revise-a e tente novamente.',
		userErrorTwo:
			'O e-mail digitado não está cadastrado. Por favor revise e tente novamente.',
		enterCodeBelow:
			'Digite o código fornecido pelo seu aplicativo de autenticação nas caixas abaixo.',
		enterYourCode: 'Digite seu código 2FA',
		authCode: 'Código de autenticação',
		loginMobile: 'Faça login em sua conta',
		loginOr: 'Ou faça login com suas credenciais:',
	},

	wellcomeComponent: {
		title: 'Obrigado por seu interesse! ',
		titlesub: 'Vamos começar sua inscrição',
		subTitle:
			'Você está prestes a se envolver em nosso processo de coleta das informações necessárias para configurar sua conta e verificar sua identidade.',
		before: 'Antes de começar, prepare os seguintes documentos:',
		government: '• Documento de identidade com foto emitido pelo governo',
		proof: '• Comprovante de residência',
		agree:
			'* Concordo em permitir que a Tradeview Financial Markets S.A.C. verifique eletronicamente minha identidade fornecendo minhas informações pessoais, inclusive documentos de identidade. Essas informações serão compartilhadas com um provedor de serviços de verificação de identidade confiável para confirmar sua exatidão e compará-las com os dados que eles possuem ou obtêm de outras fontes confiáveis.',
		agreeLATAM:
			'*Concordo em permitir que a Tradeview Financial Markets S.A.C. verifique eletronicamente minha identidade fornecendo minhas informações pessoais, inclusive documentos de identidade. Essas informações serão compartilhadas com um provedor de serviços de verificação de identidade confiável para confirmar sua exatidão e compará-las com os dados que eles possuem ou obtêm de outras fontes confiáveis.',
		btnContinue: 'Continuar',
		btnGoBack: 'Voltar atrás',
		btnConfirm: 'Confirmar',
		checkError:
			'Marque a caixa para concordar com o tratamento das informações.',
	},

	loginBox: {
		title: 'Faça login em sua conta',
		logInGoogle: 'Continuar com o Google',
		logInFacebook: 'Continuar com o Facebook',
		or: 'Ou faça login com suas credenciais:',
		email: 'E-mail',
		placeholderEmail: 'Digite seu e-mail',
		placeholderPassword: 'Digite sua senha',
		password: 'Digite sua senha',
		submit: 'Continuar',
		forgot: 'Esqueceu sua senha?',
		doNotAccount: 'Não tem uma conta?',
		signUp: 'Registre-se.',
		tryFreeDemo: 'Experimente uma demonstração gratuita',
		remember: 'Lembrar-se de mim',
		emailError: 'Por favor, digite seu e-mail',
		passwordError: 'Digite sua senha',
		passwordToEmail: 'Por favor, verifique seu e-mail',
		passwordToEmailDesc:
			'Enviamos uma senha temporária para redefinir sua conta.',
	},

	forgotPage: {
		instructionstitle1: 'Economize tempo e esforço!',
		instructionstitle2: 'Uma plataforma para cada',
		instructionstitle3: 'necessidade que você tem',
		options1f: 'Regulamentadas',
		options1l: 'e seguras',
		options2f: 'Assistência',
		options2l: 'personalizada',
		options3f: 'Liquidez',
		options3l: 'incomparável',
	},

	forgotBox: {
		title: 'Redefinir sua senha',
		email: 'E-mail',
		text1: 'Digite seu e-mail registrado abaixo e enviaremos',
		text2: 'instruções para redefinir sua senha.',
		placeholderEmail: 'Digite seu e-mail',
		badFormatEmail: `Certifique-se de que o e-mail inserido esteja em um formato válido. por exemplo. nomedeusuario@mail.com`,
		badEmail: 'Digite seu e-mail registrado',
		wrongEmail:
			'O e-mail inserido não está registrado. Revise e tente novamente.',
		continue: 'Continuar',
		limitExceeded: 'Limite excedido',
		requiredField: 'Este campo é obrigatório',
		goBackLogIn: 'Voltar para o login',
	},

	verifiCode: {
		title: 'Verifique seu endereço de e-mail',
		text1: 'Enviamos um código de ativação para o seu e-mail registrado..',
		text2: 'Verifique sua caixa de entrada e digite o código abaixo.',
		label1: 'Código de verificação',
		label2: 'Digite o código de 6 dígitos. Por exemplo, 123456',
		label3: 'O código inserido é inválido. Revise e tente novamente.',
		submit: 'Enviar',
		text3: 'Não recebeu nenhum código?',
		text4: 'Reenvie o código',
		alert1: 'Um código único foi enviado para ',
		alert2: 'Não é possível reenviar seu código no momento. Tente novamente.',
		alert3: 'Código de verificação incorreto. Tente novamente.',
		error: 'Ups! Algo deu errado. Entre em contato com nossos representantes',
	},

	setPassword: {
		title: 'Defina sua nova senha',
		text1: 'Por favor, digite sua nova senha, garantindo que ',
		text2: 'é diferente das senhas usadas anteriormente.',
		label1: 'Nova senha',
		label2:
			'A senha deve ter pelo menos 8 caracteres e incluir pelo menos uma letra minúscula, uma letra maiúscula, um número e um caractere especial.',
		label3: 'Confirmar senha',
		placeholder1: 'Digite sua nova senha',
		placeholder2: 'Confirme sua nova senha',
		error1:
			'A senha deve ter pelo menos 8 caracteres e incluir pelo menos uma letra minúscula, uma letra maiúscula, um número e um caractere especial.',
		error2:
			'As senhas inseridas não correspondem. Verifique novamente e tente outra vez.',
	},

	setPasswordSuccess: {
		title1: 'Sua senha foi',
		title2: 'redefinido com sucesso!',
		login: 'Entrar',
	},

	consoleHeader: {
		account: 'Conta #',
		balance: 'Saldo',
		equity: 'Equidade',
		free: 'Margem Livre',
		margin: 'Nível de Margem',
		status: 'Status',
		hello: 'Olá',
		logout: 'Sair',
		confirm: 'Confirmar',
		outModal: 'Tem certeza que deseja sair?',
		yes: 'Sim',
		not: 'Not',
		settings: 'Configurações',
		areYouDone: 'Você terminou?',
		areYouSure:
			'Tem certeza que deseja sair? Quaisquer alterações não salvas serão perdidas.',
		yesLogOut: 'Sim, sair',
	},

	// Platforms page
	platforms: {
		description:
			'Aproveite a facilidade de usar ferramentas de negociação importantes e informações de conta no seu dispositivo, o que lhe dá controle, esteja você em trânsito ou em sua mesa. Selecione a forma como deseja trabalhar e faça o download do software/aplicativo que melhor se adapta a você.',
		mainTitle: 'Como você deseja negociar?',
		metatrader4: {
			desc1: 'Interface fácil de usar e personalizável',
			desc2: 'Velocidades de execução rápidas para negociações eficientes',
			desc3: 'Colocação de ordens sem esforço',
			desc4: 'Gerenciamento eficaz de posições',
			desc5: 'Visualização dos movimentos de preços para decisões informadas',
		},
		metatrader5: {
			desc1:
				'Principais ferramentas de negociação e informações da conta em seu dispositivo',
			desc2: 'Alertas para não perder eventos importantes nos mercados',
			desc3: 'Suporte para negociação automatizada',
			desc4: 'Mais de 80 indicadores e ferramentas analíticas incorporados',
			desc5: 'Ferramentas avançadas para estratégias de negociação aprimoradas',
		},
		cTrader: {
			desc1: 'Experiência de negociação rápida e fácil de usar',
			desc2: 'Acesso direto aos mercados de moedas',
			desc3: 'Fácil colocação de ordenst',
			desc4: 'Visibilidade da profundidade do mercado para decisões informadas',
			desc5: 'Tecnologia avançada para negociações aprimoradas',
		},
		sterling: {
			desc1: 'Layouts personalizáveis e teclas de atalho',
			desc2: 'Informações de mercado em tempo real de Nível I e Nível II',
			desc3: 'Monitoramento em tempo real de posições e lucros/perdas',
			desc4:
				'Lista de observação de tickers personalizável com mais de 60 pontos de dados por símbolo',
			desc5: 'Pacote de gráficos com mais de 90 estudos e indicadores',
		},
		lightspeed: {
			desc1: 'Várias fontes de localização com preços variados',
			desc2:
				'Ordens personalizáveis com base em configurações pré-configuradas',
			desc3: 'Formulários de ordens de opções para estratégias complexas',
			desc4:
				'Listas de observação personalizáveis e teclas de atalho para entrada rápida de ordens',
			desc5: 'Configurações abrangentes de gerenciamento de risco',
		},

		takion: {
			desc1:
				'Vários tipos de gráficos, períodos de tempo e indicadores técnicos.',
			desc2: 'Negociação direta com acesso ao mercado para maior eficiência',
			desc3: 'Scanners de mercado em tempo real e atualizações de notícias',
			desc4: 'Dados de vendas e em tempo real de nível II.',
			desc5:
				'Camadas e espaços de trabalho para operações de negociação contínuas',
		},

		das: {
			desc1: 'Tipos avançados de ordens e gráficos em tempo real',
			desc2: 'Gerenciamento de várias contas',
			desc3: 'Teclas de atalho personalizáveis para entrada rápida de ordens',
			desc4:
				'Validação de ordens de baixa latência para as principais bolsas dos EUA',
			desc5: 'Acesso a dados de mercado em tempo real',
		},

		api: {
			desc1:
				'Conectividade direta e de alta velocidade com nossos servidores de negociação',
			desc2: 'Execução rápida e personalização da plataforma',
			desc3: 'Controle total sobre os dados enviados e recebidos',
			desc4: 'Diversas opções de ordens de mercado e de limite',
			desc5: 'Flexibilidade para sua estratégia de negociação',
		},
		cqg: {
			desc1: 'Interfaces de negociação fáceis de usar',
			desc2: 'Gráficos e análises essenciais',
			desc3:
				'Dados em tempo real em uma variedade de estilos de cotação, incluindo mapas de calor',
			desc4: 'Gerenciamento de ordens e posições',
			desc5: 'Notícias RSS',
		},
		thanksForYourInterest: 'Obrigado por seu interesse!',
		weWillContactYou:
			'Um representante da Tradeview entrará em contato com você em breve para ajudá-lo a configurar sua nova conta de demonstração.',
		createAccountToDownload: 'Crie uma conta para baixar esta plataforma',
		createAccount: 'Criar uma conta',
		platformNotCovered:
			'Essa plataforma não é coberta por sua conta existente. Para instalá-la e usá-la, crie uma conta dedicada a esse mercado e a essa plataforma',
		btn_downd: 'Baixar',
		btn_launch: 'Iniciar versão web',
		btn_request: 'Download mediante solicitação',
		okay: 'Certo',
		continue: 'Continuar',
		requestAccount: 'Solicitar uma conta',
		disabledOptionAlert:
			'Não foi possível iniciar seu download. Aguarde 10 segundos entre as tentativas de download e tente novamente.',
		modal_reminder: {
			title: 'Lembrete',
			descript1: 'Seu download está em andamento! Para acessar a',
			descript2:
				'Para acessar a plataforma_name, use as credenciais que lhe enviamos por e-mail. Se você ainda não solicitou uma conta para essa plataforma, pode fazê-lo agora ou a qualquer momento. Lembre-se,',
			descript3: 'é necessário ter uma conta para acesso.',
			descript1sub: 'Para acessar a',
			descript2sub:
				'Para acessar a plataforma_name, use as credenciais que lhe enviamos por e-mail. Se você ainda não solicitou uma conta para essa plataforma, pode fazê-lo agora ou a qualquer momento. Lembre-se,',
			descript3sub: 'é necessário ter uma conta para acesso.',
		},
		modal_send: {
			title: 'Sua solicitação foi enviada',
			descript:
				'Obrigado por seu interesse! Entraremos em contato com você em breve para ajudá-lo a configurar a plataforma selecionada.',
		},
		acessPlatforms:
			'Você precisará de uma conta para acessar essas plataformas. Você pode solicitar uma',
		acessPlatformsContinue: '',
		webVersionModal: 'Iniciar a versão web',
		toAccess:
			'Para acessar o MT5, use as credenciais que enviamos por e-mail. Se ainda não solicitou uma conta para esta plataforma, pode fazê-lo agora ou a qualquer momento. Lembre-se: uma conta é necessária para o acesso.',
		selectTypeAccount:
			'Selecione o tipo de conta que deseja usar para iniciar a versão web:',
		live: 'Real',
		demo: 'Demo',
		launch: 'Iniciar',
	},

	//History page
	history: {
		titleH: 'Seu histórico de negociação',
		periodTimeL: 'Período de tempo',
		periodTimeP: 'Todo o histórico',
		typeL: 'Tipo',
		typeP: 'Selecionar tipo',
		platformL: 'Plataforma',
		platformP: 'Selecione uma plataforma',
		accountL: 'Conta de negociação',
		accountP: 'Número da conta',
		fromL: 'De',
		fromP: 'mm/dd/aaaa',
		toL: 'Até',
		toP: 'mm/dd/aaaa',
		clearBtn: 'Limpar',
		exportBtn: 'Exportar',
		getBtn: 'Aplicar filtro',
		optionsAccounts: 'Selecione sua conta de negociação',
		infoAlertD: 'Selecione uma conta para ver seus movimentos aqui.',
		noHistoryYet1: 'Os filtros selecionados para a conta',
		noHistoryYet2: 'não têm histórico ainda',
		platformAlertD:
			'Observação: somente as contas das plataformas MT4, MT5 e cTrader serão exibidas no filtro e na tabela abaixo. Para contas em outras plataformas, você pode acessar o histórico de negociação em suas respectivas plataformas.',
		accountTypeH: 'Tipo de conta',
		accountTypeP: 'Selecione um tipo de conta',
		alertExport: 'Suas informações foram exportadas com sucesso',
		btnFilter: 'Filtros',
		alertPlatforMobile:
			'Observação: Somente as contas MT4, MT5 e cTrader são mostradas abaixo. Você pode acessar o histórico de negociação de outras plataformas nas respectivas plataformas.',
		modalHeader: 'Tem certeza de que deseja sair?',
		modalDescription:
			'Se você sair agora, o processo não será concluído e você perderá todo o progresso que fez.',
		btnModalCancel: 'Cancelar',
		btnModalYes: 'Sim, tenho certeza',
		filterbyactivity: 'Filtrar por tipo de atividade',
		accountTooltip:
			'O número da conta associado ao movimento. No caso de transferências, o ícone',
		accountTooltip2:
			'representa transferências que entraram na conta consultada, e',
		accountTooltip3: 'transferências que saíram da sua conta.',
		accountTooltipIn:
			'Uma transferência que entrou na sua conta consultada a partir da conta de origem listada nesta coluna.',
		accountTooltipOut:
			'Uma transferência que saiu da sua conta consultada e foi enviada para a conta de destino listada nesta coluna.',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: 'Conta de origem',
		currency: 'Moeda',
		currencyType: 'Tipo de moeda',
		details: 'Detalhes do Banco Beneficiário',
		beneficiaryDetails: 'Detalhes do banco beneficiário',
		swiftt: 'Swift',
		branch: 'Nome da agência',
		province: 'Província',
		city: 'Cidade',
		bankK: 'Banco',
		bankTransfer: 'Selecione um banco para sua transferência',
		withdrawFunds: 'Retire seus fundos',
		withdrawalMethod: 'Método de retirada',
		withdrawalAmmount: 'Valor disponível para retirada',
		keepInMind: 'Tenha em mente:',
		keepInMindTC:
			'Você pode realizar até 5 transações dentro de um período de 24 horas.',
		withdrawalCalendar:
			'Introducing brokers are limited to two withdrawals per calendar a month, with a minimum withdrawal amount of $100 US or equivalent in the base currency. Additional withdrawals within the same calendar month will be charged a $50 processing fee.',
		withdrawalMustMatchDeposit:
			'The withdrawal method selected must match the deposit method. For credit card and digital wallet deposits, withdrawal amounts cannot exceed the original deposit.',
		beneficiaryName: 'Nome do beneficiário',
		beneficiaryAccount: 'Conta do beneficiário',
		bankAddress: 'Endereço do banco',
		enterBankAddress: 'Digite seu endereço bancário',
		enterBeneficiaryName: 'Digite o nome do seu beneficiário',
		beneficiaryAddress: 'Endereço do beneficiário',
		enterBeneficiaryAddress: 'Insira o endereço do seu beneficiário',
		enterYourAddress: 'Digite seu endereço',
		accountNumber: 'Número da conta',
		iban: '(IBAN)',
		enterAccountNumber: 'Digite o número de sua conta',
		bankName: 'Nome do banco',
		enterBankName: 'Digite o nome do seu banco',
		swiftCode: 'Código Swift',
		enterSwiftCode: 'Digite o código swift do seu banco',
		abaNumber: 'Número ABA',
		enterAbaNumber: 'Digite o número ABA de seu banco',
		sortCodeClabe: 'Código de classificação/CLABE',
		enterSortCodeClabe: 'Digite seu código de classificação/CLABE',
		referenceNumber: 'Número de referência',
		enterReferenceNumber: 'Digite seu número de referência',
		associatedEmail: 'Conta de e-mail associada',
		associatedEmailLabel: 'E-mail associado',
		enterAssociatedEmailAccount: 'Digite seu e-mail associado',
		doYouNeedIntermediary: 'Você precisa de um banco intermediário?',
		selectAnOption: 'Por favor, selecione uma opção',
		pleaseSelectAnOption: 'Por favor, selecione uma opção',
		enterCashAmount: 'Insira um valor em dinheiro',
		helperCashTransfer:
			'Mínimo de $10 USD. As transferências superiores a 10K requerem revisão manual.',
		intermediaryBank: 'Dados bancários intermediários',
		intermediaryBankk: 'Banco intermediário',
		ifNeeded: '(Se necessário)',
		intermediaryBankName: 'Nome do banco intermediário',
		banescoAccountName: 'Nome da conta',
		clabe: 'CLABE',
		pesosAccount: 'Número da conta em pesos',
		enterIntermediaryBankName: 'Insira o nome do seu banco intermediário',
		intermediaryBankAddress: 'Endereço do banco intermediário',
		enterintermediaryBankAddress:
			'Insira o endereço do seu banco intermediário',
		ibanNumber: 'Número IBAN',
		enterIbanNumber: 'Digite seu número IBAN',
		withdrawalCompleted: 'Sua retirada foi concluída!',
		withdrawalIsComplet: 'Retirada em análise',
		withdrawalIsCompletDescription:
			'Sua retirada está sendo analisada. Nossa equipe entrará em contato com você por e-mail assim que o processo de retirada for concluído.',
		withdrawalCompletedDescription:
			'Seus fundos estarão disponíveis em sua conta de destino em breve. O tempo de processamento depende do método de retirada que você selecionou.',
		withdrawNotCompleted: 'Sua retirada não foi concluída',
		withdrawNotCompletedDescription:
			'Encontramos um problema ao processar seu depósito. Verifique suas informações de pagamento e tente novamente. Se o problema persistir, entre em',
		contactUs: 'contato conosco.',
		goToMyAccount: 'Ir para minha conta',
		creditCardDetails: 'Detalhes do cartão de crédito',
		important: 'Importante:',
		withdrawalsExceeding:
			'Retiradas que excedam o valor de seu depósito inicial não podem ser processadas por meio de cartão de crédito. Você só é elegível para sacar o mesmo valor do seu depósito inicial usando esse método. Para sacar lucros, use um método de saque alternativo.',
		creditCardLastDigits: 'Os últimos 4 dígitos do cartão de crédito',
		enterCreditCardLastDigits:
			'Digite os últimos 4 dígitos de seu cartão de crédito',
		netellerAccountDetails: 'Detalhes da conta Neteller',
		netellerComission:
			'2% sobre depósitos e saques - isenção de taxas se os fundos forem mantidos por 3 meses ou mais OU se você atender ao requisito de lote mínimo (entre em contato com o gerente da conta para obter ajuda com o cálculo do lote)',
		netellerComissionMena:
			'Gostaríamos de informar que, devido ao aumento dos custos associados ao Neteller, será cobrada uma taxa de 1% em todos os depósitos e saques realizados via Neteller. Em determinadas circunstâncias, as taxas podem ser isentas após uma revisão da sua conta com o seu representante Tradeview.',

		skrillAccountDetails: 'Detalhes da conta Skrill',
		upholdAccountDetails: 'Detalhes da conta Uphold',
		bitwalletAccountDetails: 'Detalhes da conta Bitwallet',
		interacAccountDetails: 'Detalhes da sua conta Interac e-Transfer',
		interacHelpMsg: '*Marca registrada da Interac Corp. Usada sob licença.',
		upholdComission:
			'Se estiver enviando para a conta Uphold: Sem taxa. Se estiver enviando para outra carteira de criptomoedas: A TV não cobra taxas, mas a Uphold cobra as seguintes taxas: Taxa de câmbio (1,05%), Taxa de rede (0,0003 BTC), Taxa de saque (0,0004 BTC).',
		bitPayTitle: 'Detalhes do BitPay',
		destinationAccount: 'Conta de destino',
		bitPayCommision:
			'O processador de Criptomoedas cobra as seguintes taxas: Taxa de câmbio: (1.05%), Taxa de rede:(0.0003 BTC), Taxa de saque (0.0003 BTC)',
		needYourAuth: 'Precisamos de sua autorização:',
		confirmThoughtEmail:
			'Depois de enviar esta solicitação de saque, você precisará confirmá-la por meio do e-mail registrado em sua conta.',
		wallet: 'Carteira',
		enterYourWallet: 'Insira sua carteira',
		enteryourEmailAccount: 'Digite seu e-mail',
		sticPayAccountDetails: 'Detalhes da conta SticPay',
		voletAccountDetails: 'Volet account details',
		interacAccountDetails: 'Detalhes da conta Interac e-Transfer',
		fasapayAccountDetails: 'Informações da conta Fasapay',
		searchABank: 'Pesquisar um banco',
		searchAnAccount: 'Pesquisar uma conta',
		ibanIfApplicable: '(IBAN se aplicável)',
		beneficiaryBankName: 'Nome do banco beneficiário',
		enterBeneficiaryBankName: 'Nome do banco beneficiário',
		enterYourProvince: 'Digite sua província',
		enterYourCity: 'Digite sua cidade',
		unionPayDetails: 'Detalhes do UnionPay',
		jpayDetails: 'Detalhes da conta JPay',
		jpayAccountDetails: 'Detalhes da conta JPay',
		walletAndCrypto: 'Carteira e criptomoeda',
		walletAndCryptoAlert:
			'Ao fazer um saque usando criptomoedas, há uma taxa de conversão de 0,7%.',
		crypto: 'Criptomoeda',
		selectCrypto: 'Selecione uma criptomoeda',
		tag: 'Marcação',
		enter: 'Digitar',
		cryptocurrency: 'Criptomoeda',
		enterCryptocurrency: 'Insira a criptomoeda',
		otherCurrency: 'Outra criptomoeda',
		enterOtherCurrency: 'Insira outra criptomoeda',
		areYouSure: 'Tem certeza de que deseja sair?',
		ifYouLeaveNow:
			'Se você sair agora, o processo não será concluído e você perderá todo o progresso feito.',
		noStay: 'Não, fique',
		yesLeave: 'Sim, vá embora',
		requestSubmited: 'Sua solicitação foi enviada!',
		reviewEmail: 'Revise seu e-mail registrado.',
		unsuccessfulWithdraw: 'Sua retirada não foi concluída',
		reviewAgain:
			'Por favor, reveja suas informações de retirada e tente novamente. Se o problema continuar ocorrendo,',
		amountTryAgain:
			'O valor excede o valor transferível disponível. Tente novamente.',
		amountTryAgainWithdraw:
			'O valor excede o valor disponível para saque. Tente novamente.',
		minimunAmount: 'O saque mínimo para esse método é de US$ 10.',
		minimunAmount100:
			'O valor mínimo de retirada para este método é de $100 USD.',
		minimunAmount0:
			'O valor mínimo de retirada para este método é de 0,00001 BTC.',
		invalidEmail: 'Formato de e-mail inválido',
		invalidAccountNumber: 'Formato de número de conta inválido',
		noAvailableOptions: 'Nenhuma opção disponível',
		closeModal:
			'Observe que se você optar por sair agora, qualquer progresso feito não será salvo. Se você planeja sacar seus fundos mais tarde, precisará começar novamente.',
		successWithdraw:
			'Ótima notícia! Seus fundos estarão disponíveis em sua conta de destino em breve. O tempo de processamento pode variar dependendo do método de retirada que você selecionou.',
		fundCreditCard: 'Depósito com cartão de crédito',
		selectMethod:
			'Os métodos de retirada referem-se às opções disponíveis para retirar fundos da sua conta. Você pode retirar para sua conta bancária, seu cartão de crédito, sua carteira digital ou sua carteira de criptomoedas.',
		invalidCreditCardDigits: 'Dígitos do cartão inválidos',
		phone: 'Telefone',
		enterYourPhone: 'Digite seu telefone',
		invalidPhone: 'Formato de telefone inválido',
		modalPreferences: 'Não pedir novamente o login atual',
		bankFee: '$35 USD',
		bankBranch: 'Agência bancária',
		enterBankBranch: 'Digite sua agência bancária',
		branchProvince: 'Província da agência',
		enterBranchProvince: 'Digite a província da sua agência',
		BranchCity: 'Cidade da agência',
		enterBranchCity: 'Digite a cidade da sua agência',
	},

	//Account Activity page
	accountActivity: {
		title: 'Atividade da Conta',
		from: 'De',
		to: 'Até',
		type: 'Tipo',
		platform: 'Instrumento de negociação',
		placeholderAccount: 'Conta de negociação',
		account: 'Conta de negociação',
		get: 'Obter',
		row: 'Linhas para a página',
		download: 'Baixar Relatório',
		back: 'Voltar',
		confirm: 'Confirmar',
		close: 'Fechar',
		error: 'Erro! Não pode haver campos vazios.',
		errorTwo: 'Erro! Você deve selecionar o tipo de campo.',
		activityid: 'ID da Atividade',
		platfomr: 'Plataforma',
		date: 'Data / Hora',
		activity: 'Atividade',
		profit: 'Lucro/perda',
		timeSegmentation: 'Segmentação de tempo',
		timeFrame: 'Selecione um período de tempo',
		selectType: 'Selecionar tipo',
		selectMarket: 'Selecionar mercado',
		tradingAccount: 'Selecione sua conta de negociação',
		segmentation: 'Segmentação de tempo',
		segmentationPlaceholder: 'Selecione um período de tempo',
		platformPlaceholder: 'Selecione uma plataforma',
		alert: 'Suas informações foram exportadas com sucesso',
		infoYet:
			'Os filtros que você escolheu não produziram resultados. Tente novamente.',
	},

	//tradingHistory
	tradingHistory: {
		title: 'Histórico de negociação',
		from: 'De',
		to: 'Até',
		type: 'Tipo',
		platform: 'Plataforma',
		placeholderAccount: 'Conta de negociação',
		account: 'Conta',
		get: 'Obter',
		row: 'Linhas para a página',
		download: 'Baixar Relatório',
		back: 'Voltar',
		confirm: 'Confirmar',
		close: 'Terminar',
		error: 'Erro! Não pode haver campos vazios.',
		errorTwo: 'Erro! Você deve selecionar o tipo de campo.',
		deal: 'Negociação',
		entryTime: 'Horário de entrada',
		typr: 'Tipo',
		simbol: 'Símbolo',
		volume: 'Volume',
		entryPrice: 'Preço de entrada',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: 'Hora de saída',
		exitPrice: 'Preço de saída',
		commision: 'Comissão',
		bankFee: 'Taxa bancária',
		swap: 'Troca',
		profit: 'Lucro/perda',
		dateFrom: 'aaaa/mm/dd',
		dateTo: 'aaaa/mm/dd',
		openingTime: 'Horário de abertura',
		openingPrice: 'Preço de abertura',
		stopLoss: 'Limite de perda',
		takeProfit: 'Obter lucros',
		closingTime: 'Horário de fechamento',
		closingPrice: 'Preço final',
		comission: 'Comissão',
		time: 'Tempo',
	},

	//Transfer page
	transfer: {
		mainTitle: 'Transferir seus fundos',
		isBackValidation:
			'A nossa equipa tem de analisar a sua transferência para aprovação. Isto pode demorar até 24 horas do dia útil seguinte.',
		pleaseNote:
			'Observação: as transferências só são permitidas entre contas pertencentes ao mesmo usuário.',

		mena: {
			consentCheck:
				'Ao marcar a caixa de seleção, entendo que solicitei a transferência de fundos de uma conta da Tradeview Ltd. para outra conta minha na Tradeview Ltd.',
		},
		ltd: {
			consentCheck:
				'Ao marcar a caixa de seleção, entendo que solicitei a transferência de fundos de uma conta da Tradeview Ltd. para outra conta minha na Tradeview Ltd.',
		},
		latam: {
			consentCheck:
				'Ao marcar a caixa de seleção, entendo que solicitei a transferência de fundos de uma conta da Tradeview Financial Markets S.A.C. para outra conta minha na Tradeview Financial Markets S.A.C.',
		},
		markConsentCheck:
			'Você precisa marcar a caixa de seleção de confirmação para continuar. Por favor, faça isso.',
		transferAmount: 'Valor transferível',
		transferCompleted: 'Sua transferência foi concluída',
		transferReview: 'Transferência em análise',
		transferInCompleted: 'Sua transferência não foi concluída',
		transferInCompletedDescription:
			'Encontramos um problema ao processar sua transferência. Verifique as informações de sua conta e tente novamente. Se o problema persistir, entre em',
		transferDescription:
			'Ótima notícia! Seus fundos estarão disponíveis em sua conta de destino em breve.',
		transferDescriptionReview:
			'A sua transferência está agora a ser analisada. A nossa equipa entrará em contacto consigo por e-mail assim que o processo de transferência estiver concluído.',
		destinationAccount: 'Destination account',
		minimunAmount: 'O valor mínimo transferível para esse método é de US$ 10.',
	},

	//Accounts
	accounts: {
		refresh: 'Atualizar saldos',
		liveAccounts: 'Contas',
		demoAccounts: 'Contas de demonstração',

		createLive: '+ Criar uma nova conta real',
		createDemo: '+ Criar uma nova conta demo',
		refresh: 'Atualizar saldos',
		createAccount: 'Criar uma nova conta',
		createDemoAccount: 'Criar uma nova conta demo',
		createLiveAccount: 'Criar uma nova conta real',
		livee: 'Ao vivo',
		demoo: 'Demonstração',
		yourBalance: 'Seu saldo',
		equityy: 'Equidade',
		marginLevel: 'Nível de margem',
		freeMargin: 'Margem livre',
		statuss: 'Status',
		leveragee: 'Alavancagem',
		credit: 'Crédito',
		phone: 'Telefone',
		selectLeverage: 'Selecione uma alavancagem',
		noLiveAccount:
			'Você não tem uma conta ativa. Escolha uma que atenda às suas necessidades e comece a negociar agora.',
		noDemoAccount:
			'Você não tem uma conta demo. Escolha uma que atenda às suas necessidades e comece a praticar.',
		tradingInstrument: 'Mercado de negociação',
		tradingMethodTooltip:
			"Mercados de negociação referem-se aos vários tipos de mercados com os quais você pode se envolver. Muitas vezes referidos como valores mobiliários, estes incluem futuros de commodities, ações, CFDs, moedas, metais e muito mais. <br><br> Não tem certeza de qual mercado escolher? Você pode revisá-los <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>aqui</a>",
		here: 'here',
		selectAMarket: 'Selecione um mercado',
		platform: 'Plataforma',
		selectAPlatform: 'Selecione uma plataforma',
		cashAmount: 'Valor em dinheiro',
		selectCashAmount: 'Selecione um valor em dinheiro',
		accountType: 'Tipo de conta',
		selectAnAccount: 'Selecione um tipo de conta',
		currencyy: 'Tipo de moeda',
		selectACurrency: 'Selecione uma moeda',
		platformTooltip:
			"Uma plataforma é o software que você usará para executar negociações em sua conta.<br><br> Não tem certeza de qual plataforma escolher? Você pode analisá-las  <a href='https://www.tvmarkets.com/trading/platforms' target='_blank'>aqui</a>",
		accountTypeTooltip:
			'O tipo de conta permite que você selecione as condições de negociação (alavancagem, spreads, comissões) para sua conta.',
		accountTypeTooltip2:
			'Você pode revisar as condições de cada tipo de conta aqui',
		applicationCompleted: 'Sua solicitação foi concluída!',
		applicationCompletedDescription:
			'Sua solicitação de conta ativa está sendo analisada e será verificada em breve. Um de nossos consultores entrará em contato com você se for necessária documentação adicional.',
		applicationError: 'Sua solicitação não foi enviada',
		applicationErrorDescription:
			'Ocorreu um erro ao enviar sua solicitação. Nossa equipe técnica foi informada sobre esse problema. ',
		applicationErrorDescription2:
			'Por favor, tente novamente e, se o problema continuar,',
		sureToLeave: 'Tem certeza de que deseja sair?',
		processUncompleted:
			'Se você sair agora, o processo não será concluído e você perderá todo o progresso que fez.',
		cardPlatform: 'Plataforma',
		setDemoAccount:
			'Estamos configurando sua nova conta de demonstração. Quando ela estiver pronta, você encontrará todos os detalhes aqui.',
		cancel: 'Cancelar',
		active: 'Ativa',
		accountSettings: 'Configurações da conta',
		changePw: 'Alterar a senha desta conta',
		changeLv: 'Alterar a alavancagem desta conta',
		setLv: 'Defina a nova alavancagem da sua conta',
		underReview: 'Sua atualização está em revisão',
		underReviewDesc:
			'A nova alavancagem da sua conta está em revisão e será verificada em breve. Nossa equipe entrará em contato por e-mail assim que o processo for concluído.',
		successLev: 'Sua alavancagem foi atualizada com sucesso!',
		changePsw: 'Alterar sua senha',
		forgotPw: 'Esqueceu sua senha? Por favor, {contact}.',
		updatePw: 'Sua senha foi atualizada com sucesso!',
		statusTooltip:
			'Sua conta pode estar inativa por vários motivos, como a falta de informações ou documentos solicitados. Verifique seu painel para possíveis alertas. Se você não tiver certeza do motivo, por favor, {contact}.',
		failedReq: 'Desculpe! Ocorreu um erro',
		failedReqDesc:
			'Por favor, tente novamente. Se o problema continuar, {contact} para obter assistência.',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: 'Entrar',
		pass: 'Senha',
		currencyTwo: 'Moeda',
		server: 'Servidor',
		ilc: 'iLC',
		xleverage: 'xLeverage',
		dontForget:
			'Não se esqueça de salvar suas credenciais antes de clicar em qualquer botão ou fechar esta janela. Essas informações também serão enviadas para o seu e-mail registrado.',
		downloadCred: 'Baixar credenciais',
		choosePlatform:
			'Ótimo! Agora você está pronto para escolher e baixar sua plataforma de negociação',
		ifYouChooseMT4:
			'Se você escolheu o MetaTrader 4 para Mac OS, observe que o processo de instalação é diferente. Você pode encontrar orientações sobre a instalação',
		ifYouChooseMT4Continuation: '',
		thanksForRegistering: 'Obrigado por se registrar!',
		otherStock:
			'Um representante da Tradeview entrará em contato com você em breve para ajudá-lo a configurar sua nova conta de demonstração.',
		stockMT52:
			'Enquanto sua conta estiver sendo configurada, sinta-se à vontade para',
		stockMT53: 'explorar nosso site',
		stockMT54: 'e descobrir mais sobre a Tradeview.',
		accountTypeDemo:
			"O tipo de conta permite que você selecione a alavancagem que pode obter em sua conta<br><br> X-Leverage: 1:400 <br> ILC: 1:200 <br> Stock: 1:1 <br><br> Não tem certeza de qual tipo de conta escolher? Você pode analisá-los <a href='https://www.tvmarkets.com/trading/accounts/' target='_blank'>aqui</a>",
		applicationCompleted: 'Sua conta de demonstração foi criada!',
		pdfCredentialTitle: 'Caro trader',
		pdfCredentialDescription1:
			'Obrigado por nos escolher para iniciar sua jornada de trading.',
		pdfCredentialDescription2: 'Estamos entusiasmados em tê-lo a bordo.',
		pdfCredentialDescription3: 'Aqui estão as credenciais da sua conta:',
		pdfCredentialEmail: 'E-mail:',
		pdfCredentialPassword: 'Senha:',
		pdfCredentialCurrency: 'Moeda:',
		pdfCredentialServer: 'Servidor:',
		pdfCredentialInstructions: 'Instruções:',
		pdfCredentialInstructions2: 'Use seu e-mail e senha registrados',
		pdfCredentialTo: 'para',
		pdfCredentiallogin: 'fazer login',
		pdfCredentialTVAccount: 'em sua conta Tradeview.',
		pdfCredentialChangeP:
			'Altere sua senha ou configure a autenticação de dois fatores',
		pdfCredentialSettings: 'na seção "Configurações" do Gabinete.',
		pdfCredentialFamiliarize:
			'Familiarize-se com nossa plataforma, explore os recursos,',
		pdfCredentialExperience:
			'e comece a experimentar a diferença da Tradeview.',
		pdfCredentialSupport:
			'Estamos aqui para apoiá-lo em cada passo do caminho. Se você tiver alguma dúvida',
		pdfCredentialNeed:
			'ou precisar de assistência, não hesite em entrar em contato com nossa equipe de',
		pdfCredentialTeam: 'suporte.',
		pdfCredentialHappy: 'Feliz trading!',
		pdfCredentialRegards: 'Atenciosamente,',
		pdfCredentialTVTeam: 'A equipe Tradeview',
	},

	//Create Live Accounts
	liveAccount: {
		login: 'Entrar',
		pass: 'Senha',
		server: 'Servidor',
		platform: 'Plataforma',
		status: 'Status',
		statusFalse: 'Ativado',
		statusTrue: 'Desativado',
		dontForget:
			'Não se esqueça de salvar suas credenciais antes de clicar em qualquer botão ou fechar esta janela. Essas informações também serão enviadas para o seu e-mail registrado.',
		downloadCred: 'Baixar credenciais',
		applicationCompleted: 'Sua conta live foi criada!',
	},

	//credit card
	credit: {
		edit: 'Editar',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: 'Valor',
	},

	//fidelity
	fidelity: {
		routingNum: 'Número de roteamento',
		swiftCodebic: 'Código Swift/BIC',
		disclaimer:
			'Estas instruções de depósito são apenas para residentes das Ilhas Cayman. Por favor, use um banco alternativo se você não estiver enviando das Ilhas Cayman.',
	},

	//Bbva
	bbva: {
		ruc: 'RUC',
		accountninfo: '0011-0351-0100035781',
		nameBenef: 'Nome do beneficiário',
		interbank: 'Número interbancário (CCI)',
	},

	//deposit
	deposit: {
		title: 'Selecione um método de depósito',
		depositMethod: 'Método de depósito',
		processingCards: 'TEMPO DE PROCESSAMENTO',
		fee: 'TAXA',
		crypto: 'Cripto',
		digitalWallets: 'Carteiras digitais',
		cardTransfer: 'Cartão',
		wireTransfer: 'Transferência eletrônica',
		btnDepositFunds: 'Depositar fundos',
		selectAnOption: 'Selecione um método de financiamento',
		depositUnderReview: 'Depósito em análise',
		depositUnderReviewDescription:
			'Seu depósito está atualmente em análise. Nossa equipe entrará em contato com você por e-mail assim que o processo de depósito for concluído.',
		depositUnderReviewErrorDescription:
			'Encontramos um problema ao processar seu depósito. Por favor, verifique suas informações de pagamento e tente novamente. Se o problema persistir, entre em contato conosco.',
		depositCompleted: 'Seu depósito foi concluído!',
		depositCompletedDescription:
			'Seus fundos estarão disponíveis em sua conta de destino em breve. O tempo de processamento depende do método de depósito que você selecionou.',
		despositInCompletedDescription:
			'Encontramos um problema ao processar seu depósito. Verifique suas informações de pagamento e tente novamente. Se o problema continuar',
		contactUs: 'entre em contato conosco',
		depositNotCompleted: 'Seu depósito não foi concluído',
		depositNotCompletedDescription:
			'Revise suas informações de depósito e tente novamente. Se o problema persistir, entre em contato conosco.',
		depositWithClick:
			'Ou deposite facilmente com apenas um clique ou um olhar.',
		keepInMind: 'Tenha em mente:',
		ltd: {
			depositDisclaimer:
				'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Ltd. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		},
		latam: {
			depositDisclaimer:
				'Losses can exceed the initial invested amount. Third-party deposits will NOT be accepted. All deposits must be made by the account owner. The trading platform denomination is the American Dollar.Tradeview Financial Markets S.A.C. reserves the right to return/refund deposits made via credit cards instead of processing a withdrawal.',
		},
		accountNumberTitle: 'Número da conta de negociação',
		accountNumberDescription: 'Selecione a conta que você deseja financiar',
		currencyTitle: 'Moeda',
		currencyDescription: 'Selecione uma moeda',
		amountTitle: 'Valor',
		amountDescription: 'Insira um valor em dinheiro',
		phoneNumberTitle: 'Número de telefone',
		confirmTitle: 'Revise os detalhes de sua transação',
		confirmDescription:
			'Verifique se os detalhes da transação abaixo estão corretos:',
		upholdCommission:
			'Users are responsible for covering transaction fees. Fee values depend on the transfer amount',
		upholdBanningTitle: 'Regiões geográficas não disponíveis',
		upholdBanningDescription:
			'Uphold não oferece seus serviços a residentes dos seguintes países:',
		depositAmount: 'Insira o valor do seu depósito.',
		btcAlertTitle: 'Comissão de depósito BTC',
		btcAlertMessage:
			'Uma taxa de conversão de BTC Fiat será aplicada a todas as transações. A taxa é de 1% para transações até $250 mil e 1,5% para transações acima de $250 mil.',
		upholdWarningTitle: 'Depósito direto em BTC para comissão da Tradeview',
		upholdWarningMessage:
			'Taxa de conversão BTC Fiat de 1% para todas as negociações até US$ 250 mil e 1,5% para todas as negociações acima de US$ 250 mil.',
		bitPayCommission:
			'As taxas de transação em criptomoedas são assumidas pelos usuários (os valores dependem do montante transferido).',
		bitPayWarningTitle:
			'O processador de Criptomoedas cobra as seguintes taxas:',
		bitPayWarningMessage:
			'Taxa de câmbio:  (1.05%), Taxa de rede: (0.0003 BTC), Taxa de saque (0.0003 BTC).',
		bitpayFooterInfo:
			'Lembre-se de que: A Tradeview não é responsável por qualquer ganho ou perda nas taxas de câmbio durante qualquer transação.',
		interacFooterInfo:
			'A Tradeview Financial Markets S.A.C. reserva-se o direito de devolver/reembolsar depósitos feitos via cartões de crédito em vez de processar uma retirada',
		tetherWarningTitle: 'Commission',
		tetherWarningMessage:
			'Ao fazer um depósito usando criptomoedas, há uma taxa de conversão de 0,7%.',
		copied: 'Copiado!',
		tetherHashTitle: 'Hash',
		tetherHashDescription: 'Digite seu hash',
		tetherTooltip:
			'Um hash é um código composto por números e letras que são gerados aleatoriamente por meio de criptografia.',
		netellerFooterInfo:
			'As perdas podem exceder o valor inicial investido. Depósitos de terceiros NÃO serão aceitos. Todos os depósitos devem ser feitos pelo titular da conta. A denominação da plataforma de negociação é o dólar americano. A Tradeview Ltd. reserva-se o direito de devolver/reembolsar depósitos feitos via cartão de crédito em vez de processar uma retirada.',
		fasapayAccountTitle: 'Conta FasaPay',
		fasapayAccountDescription: 'Digite seu ID de conta FasaPay',
		jpayFooterInfo: 'Taxa de câmbio: 1 USD = 7 CNY (RMB)',
		addressTitle: 'Endereço',
		zipCodeTitle: 'Código postal',
		zipCodeDescription: 'Coloque seu codigo Postal',
		countryTitle: 'País',
		countryDescription: 'Escolha o seu país',
		cityTitle: 'Cidade',
		cityPlaceholder: 'Selecione sua cidade',
		skrillFooterInfo:
			'As perdas podem exceder o valor inicial investido. Depósitos de terceiros NÃO serão aceitos. Todos os depósitos devem ser feitos pelo titular da conta. A denominação da plataforma de negociação é o dólar americano. A Tradeview Ltd. reserva-se o direito de devolver/reembolsar depósitos feitos via cartão de crédito em vez de processar uma retirada.',
		bitwalletFooterInfo:
			'As perdas podem exceder o valor inicial investido. Depósitos de terceiros NÃO serão aceitos. Todos os depósitos devem ser feitos pelo titular da conta. A denominação da plataforma de negociação é o dólar americano. A Tradeview Ltd. reserva-se o direito de devolver/reembolsar depósitos feitos via cartão de crédito em vez de processar uma retirada.',
		clickBank:
			'Clique no nome do banco de sua preferência para acessar as informações essenciais da conta e iniciar o depósito por meio da plataforma do seu banco. Quando a transferência for concluída, envie o recibo da transação para seu corretor. Após a validação da corretora, seus fundos serão imediatamente adicionados à sua conta de negociação.',
		banks: 'Bancos',
		validateDeposit:
			'Para validar seu depósito, envie o recibo da transação ao seu corretor assim que a transferência estiver completa. Após a validação, seus fundos serão adicionados rapidamente à sua conta de negociação, garantindo um processo eficiente e sem complicações.',
		processingTime: 'Tempo de processamento:',
		commision: 'Comissão:',
		bankProcessingTime:
			'Tempo de processamento: 1 a 2 dias úteis aproximadamente.',
		bankCommision: 'Comissões: Não',
		sameDay: 'No mesmo dia',
		depositInstructions:
			'Estas instruções de depósito são para uso exclusivo de residentes das Ilhas Cayman. Utilize um banco alternativo se não estiver enviando a partir das Ilhas Cayman.',
		downloadInfo: 'Informações para download',
		intermediaryBank: 'Nome do banco intermediário',
		intermediarySwift: 'Intermediário swiftt',
		beneficiarySwift: 'Beneficiário swift:',
		beneficiaryBank: 'Banco do beneficiário',
		paymentProvider: 'Endereço do provedor de pagamento',
		accountHolder: 'Nome do titular da conta',
		virtualIban: 'IBAN virtual',
		bic: 'BIC',
		createLiAcc: 'Criar uma conta real',
		waitTitle: 'Carregando nova guia',
		waitDescription:
			'Não feche esta janela. Uma nova guia será aberta automaticamente para continuar o processo. Você pode continuar navegando ou aguardar aqui enquanto isso.',
		depositTypeTitle: 'Selecione um tipo de depósito',
		depositTypeDescription:
			'Escolha o tipo de depósito de sua preferência e o método de pagamento correspondente',
		typeCash: 'Pagamento em dinheiro',
		typeBankTransfer: 'Transferência bancária',
		countryBankTitle: 'Método de pagamento',
		countryBankDescription: 'Selecione um método de pagamento',
		minimumAmount: 'O valor mínimo para',
		maximumAmount: 'O valor máximo para',
		pleaseNote: 'Observe:',
		withdrawalchooseMatch:
			'O método de saque que você escolher no futuro deve corresponder ao método de depósito.',
		notResponsibleDuringTransactions:
			'A Tradeview não é responsável por quaisquer ganhos ou perdas resultantes de mudanças na taxa de câmbio durante as transações.',
		minDeposit: 'O valor mínimo de depósito para este método é de $100',
		cryptos: {
			comission: {
				title: 'Comissão',
				text: 'A Tradeview não cobra taxa de depósito. Há uma taxa de câmbio de 0,7% cobrada por nosso processador.',
			},
			scanText1:
				'Escaneie este código QR usando a função de escaneamento no seu aplicativo de exchange',
			scanText2: 'ou copie manualmente o endereço de criptomoeda abaixo:',
			copyText:
				'Copie o endereço de criptomoeda abaixo e cole no seu aplicativo de troca:',
		},
		processTimeSameDay: 'No mesmo dia',
		processTimethreeDay: 'Até 3 dias',
		commisionYes: 'Sim',
		commisionNo: 'Não',
		onReviewTitle: 'Depósito em revisão',
		onReviewText:
			'Seu depósito está agora em revisão. Nossa equipe entrará em contato com você por e-mail assim que o processo de depósito for concluído.',
		bitPayFees: 'O criptoprocessador cobra as seguintes taxas:',
		bitPayExchange:
			'Taxa de câmbio: 1.05% <br> Taxa de rede: 0.0003 BTC <br> Taxa de saque: 0.0003 BTC',
		minimumAndMaxiumAmountInterac: 'Mín. $75 CAD - Máx. $9,999 CAD',
		routingNumber: 'Número de roteamento (ABA)',
		beneficiaryBankAddress: 'Endereço do banco beneficiário',
		beneficiaryAccountNumber: 'Número da conta do beneficiário',
		beneficiaryAccountName: 'Nome da conta do beneficiário',
		paymentDetailsFFC: 'Detalhes de pagamento FFC',
		iban: 'IBAN',
		swiftBic: 'SWIFT/BIC',
		currencies: 'moedas',
		sortCode: 'Código de classificação',
		entersortCode: 'Por favor, insira seu código de classificação',
		beneficiary: 'Beneficiário',
		beneficiaryIBAN: 'IBAN/Conta do beneficiário',
		cci: 'CCI',
		moreInformationTitle: 'Informações adicionais necessárias',
		moreInformationText:
			'Quando o total dos seus depósitos atingir 25.000 USD ou mais, uma verificação adicional única será necessária. Para completar o seu depósito, clique em "Continuar" e forneça os detalhes solicitados sobre o emprego e financeiros.',
		moreInformationTextLTD:
			"É necessária uma verificação adicional única. Para concluir o seu depósito, clique em 'Continuar' e forneça as informações solicitadas de emprego e financeiras.",
		noOptions: 'nenhuma opção disponível',
		digitalWalletsDisclaimer:
			'• As perdas podem exceder o valor inicial investido. <br> • Depósitos de terceiros NÃO serão aceitos.Todos os depósitos devem ser feitos pelo titular da conta. <br> • A denominação da plataforma de negociação é o Dólar Americano.',
		continueWithMyExchangeApp: 'Continuar com meu aplicativo de câmbio',
		continueWithPayX: 'Continuar com PAY X',
		orDepositDirectly: 'Ou depositar diretamente:',
		maximumAmountPSE_COL:
			'Para o método de pagamento PSE, o valor máximo é de 600 USD.',
	},

	//Email
	email: {
		company: 'Notícias da empresa',
		selectOne: "Notícias de negociação ( Surf's Up! )",
		selectTwo: "Surf's Up!",
		update: 'Atualizar',
		manageSubscription:
			'Gerencie suas assinaturas aqui. Selecione os tópicos dos quais você gostaria de receber boletins informativos com sua marca:',
		dontReceiveEmails:
			'Se você não quiser mais receber e-mails sobre qualquer um dos tópicos acima, basta desmarcá-los. Não se esqueça de clicar no botão "Update" (Atualizar).',
		creditCards: 'Cartões de crédito',
	},

	//password
	password: {
		title: 'Alterar a senha',
		subTitle:
			'Para alterar sua senha, solicite um código único para sua conta de e-mail.',
		request: 'Código de solicitação',
		submit: 'Enviar',
		code: 'Código',
		current: 'Senha atual',
		confirm: 'Confirme a nova senha',
		setPasswordPreference: 'Defina as preferências de sua conta',
		mailingSubscriptions: {
			title: 'Suas assinaturas de mala direta',
			description:
				'Gerencie suas assinaturas aqui. Receba os principais insights e análises diretamente em sua caixa de entrada ou informações da empresa para se manter atualizado.',
			subscriptionUpdated: 'Suas assinaturas foram atualizadas',
			subscriptionError:
				'Ups! Algo está errado, entre em contato com o suporte',
		},
		passwordSettings: {
			title: 'Suas configurações de senha',
			description:
				'Gerencie suas configurações de senha para garantir a segurança de suas contas. Aqui você pode alterá-la sempre que desejar.',
		},
		factor2Verification: {
			title: 'Defina sua autenticação de dois fatores',
			description:
				'Reforce a segurança de sua conta adicionando esse protocolo. Evite o acesso não autorizado à sua conta exigindo um código de segurança sempre que fizer login.',
			firstStepTitle: 'Etapa 1: Baixe um aplicativo de autenticaçãop',
			firstStepFirstParagraph:
				'Baixe um aplicativo de autenticação em seu dispositivo móvel. Recomendamos que você procure o Google Authenticator na Play Store ou na App Store. ',
			firstStepSecondParagraph:
				'Ao ativar a autenticação em duas etapas (2FA), você precisará digitar sua senha e um código que aparecerá no aplicativo de autenticação.',
			turnOn: 'Ativar',
			secondStepTitle: 'Etapa 2: Digite o código de autenticação',
			scanQRCode:
				'Digitalize o seguinte código QR usando o aplicativo de autenticação e insira o código de seis dígitos mostrado no aplicativo de autenticação',
			enterCodeManually:
				'Enter the six-digit code shown in the authentication app',
			invalidCode: 'O código inserido é inválido. Tente novamente.',
			authCompleted:
				'Seu código de autenticação em nossa plataforma foi concluído com êxito.',
			disable: 'Desativar',
			succesfullyActivatedAuth:
				"Bom trabalho. Você concluiu com êxito o processo de autenticação, adicionando uma camada extra de segurança à sua conta. Se você decidir alterar essas configurações, basta localizar e clicar no botão 'Disable' (Desativar).",
			deactivatedNotification:
				'Sua autenticação de dois fatores foi desativada.',
			insertCode: 'Insira o código 2FA',
			downloadAuth: 'Faça download do Google Authenticator',
			enterAuthCode: 'Digite seu código de autenticação',
			codeSuccess: 'O código em nossa plataforma foi um sucesso',
		},
		accountPreferences: 'Preferências de sua conta',
		changeYoutPassword: 'Alterar sua senha',
		requestChangePassword:
			'Se quiser alterar sua senha, será necessário solicitar um código único para seu e-mail registrado.',
		requestCode: 'Código de solicitação',
		didntGetIt: 'Não recebeu o código?',
		tryAgain: 'Tente novamente',
		enter6DigitCode: 'Digite o código de 6 dígitos. Por exemplo, 123456',
		enterValidOTP: 'O código inserido é inválido. Tente novamente.',
		notYourCurrentPassword: 'Esta não é sua senha atual',
		passwordConditions:
			'A senha deve ter pelo menos 8 caracteres e incluir pelo menos uma letra minúscula, uma letra maiúscula, um número e um caractere especial.',
		passwordsDontMatch:
			'As senhas inseridas não correspondem. Verifique novamente e tente outra vez.',
		newPassword: 'Nova senha',
		confirmPassword: 'Confirmar senha',
		passwordSuccessfulyChanged: 'Sua senha foi redefinida com sucesso!',
		sampleEmail: 'Um código único foi enviado para ',
		cantResendCode:
			'Não é possível reenviar seu código no momento. Tente novamente',
		enterCurrentPassword: 'Digite sua senha atual',
		enterNewPassword: 'Digite sua nova senha',
		enterConfirmNewPassword: 'Confirme sua nova senha',
		passwordUpdated: 'Sua senha foi redefinida com sucesso!',
		successful2Factor:
			'Sua autenticação de dois fatores foi concluída com sucesso!',
		areYouSure: 'Tem certeza de que deseja desativar a 2FA?',
		changePasswordDescription:
			'Altere as configurações de sua conta, gerencie suas assinaturas e garanta a segurança de sua conta.',
	},

	//Contact
	contact: {
		requestCall: 'Solicitar uma ligação',
		phoneNumber: 'Número de telefone',
		preferedTime: 'Horário preferido',
		selectPreferedTime:
			'Selecione o horário de sua preferência para receber a chamada',
		enterPhone: 'Ingresa tu número de teléfono ',
		knowMore: 'Saiba mais sobre nós',
		callSchedule: 'Sua chamada foi agendada',
		callScheduleDescription:
			'Entraremos em contato com você assim que um de nossos agentes for designado para a sua chamada. Observe que essa chamada ocorrerá dentro de 24 horas de sua solicitação, a partir do dia útil seguinte.',
		failedToSchedule: 'Não foi possível agendar sua chamada',
		contactUsErrorCall:
			'Pedimos desculpas pelo inconveniente. Tente novamente. Se o problema persistir, sinta-se à vontade para usar qualquer outra opção disponível para se conectar conosco.',
		weWillContactYou:
			'Um de nossos agentes de atendimento entrará em contato com você dentro do período de tempo selecionado.',
		unableToContactYou:
			'Infelizmente, não foi possível agendar a chamada no momento. Verifique novamente suas informações e tente outra vez.',
		infoInvalid:
			'As informações fornecidas não são válidas. Revise e tente novamente.',
		inNeedOfHelp: 'Precisa de assistência? Estamos aqui para ajudar!',
		inNeedOfHelpDescription:
			'Se você quiser atualizações adicionais sobre suas solicitações ou precisar confirmar detalhes sobre suas contas, estamos à sua disposição!  Entre em contato conosco e nós o ajudaremos.',
		chatDescription:
			'Você se sente mais confortável no bate-papo? Estamos a apenas uma mensagem de distância!',
		chatDescription1:
			'Nossos agentes estão disponíveis 24 horas por dia, 7 dias por semana, nos dias úteis dos EUA.',
		mailForward:
			'Não é tão urgente? Envie-nos um e-mail com suas dúvidas ou preocupações, e entraremos em contato com você o mais rápido possível.',
		emailUs: 'Envie-nos um e-mail',
		letsChat: 'Vamos conversar',
		scheduleACall: 'Agende uma chamada',
		contactDisclaimer:
			'Se preferir, você pode entrar em contato conosco diretamente pelo telefone',
		orVia: 'ou pelo e-mail ',
		contactDisclaimerLatam:
			'Se preferir, pode entrar em contato conosco diretamente pelo e-mail',
		stayConnected: 'Fique conectado conosco',
		timeZone: 'Fuso horário',
		selectTimeZone: 'Selecione um fuso horário',
		customDate: 'Quero selecionar uma data e um horário',
		soonAsPossible: 'O mais rápido possível',
		callWhen: 'Quando devemos ligar para você?',
		contactHelper:
			"Observação: nossas chamadas telefônicas agendadas são realizadas exclusivamente em inglês. Se você escolher a opção 'O mais rápido possível', entraremos em contato dentro de 24 horas no próximo dia útil.",
		selectDate: 'Selecione uma data',
		selectTime: 'Selecione um horário',
		selectOption: 'Selecione uma opção',
		preferredDate: 'Data preferida',
		sendEmail: 'Envie-nos um e-mail',
		subject: 'Assunto',
		describeEmail: 'Descreva a finalidade de seu e-mail',
		concerns: 'Escreva suas perguntas, preocupações ou comentários aqui.',
		yourMessage: 'Sua mensagem',
		emailSuccessful:
			'Seu e-mail foi entregue com sucesso! Entraremos em contato com você o mais assim que possível.',
		emailSuccessfulTitle: 'E-mail recebido',
		emailErrorfulTitle: 'Problema na entrega do e-mail',
		emailErrorMessage:
			'Pedimos desculpas pelo inconveniente. Tente novamente. Se o problema persistir, sinta-se à vontade para usar qualquer outra opção disponível para se conectar conosco.',
		japanNotice:
			'Para o fuso horário padrão do Japão, as chamadas estão disponíveis somente entre 22h e 12h ou às 6h. Pedimos desculpas antecipadamente pelo inconveniente.',
		messageError: 'A mensagem não pode exceder 900 caracteres',
		messageErrorShort: 'A mensagem deve ter pelo menos 15 caracteres',
		titleError: 'O assunto não pode exceder 60 caracteres',
		titleErrorShort: 'O assunto deve ter pelo menos 4 caracteres',
		preferredDate: 'Data preferida',
		failedAttempt: 'Por favor, tente novamente mais tarde',
		callDate: 'Sua chamada está agendada',
		contactSetDate:
			'Um de nossos agentes entrará em contato com você na data e hora selecionadas:',
		errorPhoneNumber: 'O número de telefone não pode conter letras ou símbolos',
		callDescription:
			'Deseja falar com um de nossos agentes? Respeitamos seu tempo. Agende um horário conveniente para você!',
	},

	//menu
	menu: {
		appli: 'Formulários',
		account: 'Contas',
		platforms: 'Downloads',
		history: 'Histórico',
		deposit: 'Depósito',
		transfer: 'Transferências',
		withdraw: 'Retirada',
		tradingTools: 'Ferramentas de negociação',
		settings: 'Configurações',
		passwordsettings: 'Configurações de senha',
		emailsettings: 'Configurações de e-mail',
		authenticationsettings: 'Configurações de autenticação',
		contactUs: 'Entre em contato conosco',
		accessDemo: 'Acessar conta demo',
		accessRestricted: 'Acesso restrito',
		btnReSubmit: 'Reenviar documento',
		temporarilyUnavailable:
			'Esses recursos estão temporariamente indisponíveis',
		sorryFeature:
			'Desculpe, mas os recursos que você está tentando acessar ainda não estão disponíveis. Assim que você concluir o processo de inscrição e configurar sua conta, poderá acessá-los.',
		btnContinue: 'Continuar',
		liveFeature: 'Esses são recursos de conta ao vivo',
		featureOnly:
			'Os recursos que você está tentando acessar estão disponíveis apenas para contas ao vivo. Crie uma conta ao vivo agora para obter acesso.',
		call: 'Sem tempo a perder? Nossa equipe de suporte está a um telefonema de distância, 24/5 GMT.',
		chat: 'Prefere conversar? Vamos fazer isso. Nossos agentes estão disponíveis 24/7 nos dias úteis nos EUA.',
		mail: 'Não é tão urgente? Envie-nos um e-mail, nossos especialistas responderão.',
		call2: 'Ligue para nós',
		chat2: 'Converse conosco',
	},

	//sidebar applications process
	sidebar: {
		help: 'Precisa de ajuda?',
		call: 'Entre em contato conosco',
		chat: 'Converse conosco',
		mail: 'Envie-nos um e-mail',
		notReady: 'Não está pronto para uma conta real?',
		btnDemo: 'Crie uma conta de demonstração',
	},

	//form signature
	formSignature: {
		authorised: 'Assinatura autorizada do cliente, assine acima',
		or: 'OU',
		accept: 'Confirmar assinatura ',
		error1: 'Você não confirmou a assinatura, por favor, faça isso.',
		drop: 'Coloque seus arquivos aqui ou',
		browse: 'navegue',
		make: 'Certifique-se de que o arquivo esteja no formato JPEG, PNG ou PDF e que seu tamanho não exceda 2 MB.',
		error_help:
			'Se você não carregou um arquivo com sua assinatura, faça isso.',
	},

	//Text of application process form
	applicationForm: {
		liveIndividual: 'Conta individual ativa',
		liveJointAccount: 'Conta conjunta ativa',
		primaryAccountHolder: 'Titular principal da conta',
		title: 'Detalhes pessoais',
		subtitlePlatform:
			'Depois de criar sua primeira conta Tradeview, você pode facilmente abrir mais contas para diferentes ativos financeiros sem a necessidade de preencher todo o formulário novamente.',
		subtitleDocument:
			'Que tipo de documentação você gostaria de usar para verificação?',
		subtitleResidence:
			'Qual tipo de comprovante de residência você gostaria de usar para verificação?',
		subtitleExperience:
			'Selecione a opção que melhor representa sua experiência de negociação em Forex, ações, futuros, derivativos ou CFDs.',
		submitContact: 'Contate-nos',
		drop: 'Coloque seus arquivos aqui ou',
		browse: 'navegue',
		make: 'Certifique-se de que o arquivo esteja no formato JPEG, PNG ou PDF e que seu tamanho não exceda 2 MB.',
		makeMaxSize:
			'Certifique-se de que o arquivo esteja no formato JPEG, PNG ou PDF e que seu tamanho não exceda 15 MB.',
		tryAgain: 'Tente novamente',
		openFile: 'Abrir Arquivo',
		submitted: 'Solicitação enviada: revisão em andamento',
		thankyou:
			'Obrigado por enviar sua solicitação de conta. Sua solicitação está sendo analisada e será verificada em breve.',
		operations:
			'Nossa equipe de operações entrará em contato com você caso seja necessária alguma documentação adicional.',
		appreciate:
			'Agradecemos sua cooperação e o manteremos atualizado sobre o progresso.',
		gotocabinet: 'Ir para o meu gabinete',
		explore: 'Explorar o Tradeview',
		acknowledgementText:
			'Ao assinar abaixo, eu reconheço e concordo com os documentos listados na etapa anterior deste processo.',
		acknowledgementTextLATAM:
			'Revise e compreenda cuidadosamente cada item desta página antes de marcar as caixas de acordo e assinar.',
		secondaryAccount: 'Adição de titular secundário',
		secondaryAccountDesc:
			'Para concluir a configuração da conta, é obrigatório criar o segundo titular da conta.',
		primaryAccountHolder: 'Titular da conta principal (você):',
		secondaryAccountHolder: 'Titular secundário da conta:',
		corporateResol: 'Resolução Corporativa',
		corporateResolDisclaimer:
			'Para fazer o upload do arquivo, solte seus arquivos no campo ou navegue usando o ícone.',
		corporateResolDisclaimer2:
			'Certifique-se de que o arquivo esteja no formato JPEG, PNG ou PDF e que seu tamanho não exceda 2 MB.',
		corporateResolDesc:
			'Você pode baixar e preencher a resolução corporativa padrão da Tradeview clicando {link}, ou pode fornecer a sua própria.',
		shareHolder: 'Adição de acionista',
		shareHolderDesc:
			'Adicione até 9 acionistas, cada um com uma participação mínima de 10%, ou pule esta etapa para uma conta corporativa sem acionistas.',
		addShareholder: 'Adicionar um novo acionista',
		accountHolderDisclaimer:
			'Para acionistas que possuem mais de {percentage} da empresa, exigimos informações pessoais, identidade e comprovante de endereço. Para acionistas com menos de {percentage} de participação, solicitamos apenas o nome e sobrenome.',
		deleteShareholder:
			'Para editar as ações ou carregar o ID e comprovante de endereço de um acionista, é necessário excluir o registro existente e adicioná-lo novamente.',
		sendInvitation: 'Enviar convites',
		inviteSentSuccess: 'O convite foi enviado com sucesso',
		inviteSentSuccessDesc:
			'Acompanhe o progresso da solicitação de cada acionista na seção de Informações do Acionista.',
		primaryHolder: 'Titular da conta (você)',
		sharePercent:
			'As ações representam a propriedade na empresa. Alocar percentagens aos acionistas define a participação deles na estrutura corporativa.',
		accountHolder: 'Titular da conta (você)',
		shareHolderDetails: 'Detalhes do acionista {user}:',
		continueNoShareholder: 'Continuar sem acionistas',
		infoSwitchOff:
			'Se exigido pela sua jurisdição, nossa equipe de backoffice solicitará isso de você no futuro.',
		fileNotValid: 'Carregue um arquivo em um formato e tamanho válidos.',
		resolUpload:
			'Certifique-se de que as informações e imagens do arquivo sejam claras e compreensíveis. <br/><br/>Sinta-se à vontade para carregar os documentos que você tem no momento. Não se preocupe se alguns estiverem faltando; você pode carregá-los ou enviá-los mais tarde, mediante solicitação.',
		upDocument: 'Upload de documentos',
		expiredDocument: {
			resubmit: 'Reenviar seus documentos',
			settingsDesc:
				'Atualize seus documentos de identificação e/ou comprovante de endereço reenviando-os aqui para continuar operando sem problemas.',
			resubmitDesc:
				'Seus documentos de verificação expiraram. Carregue um novo arquivo agora ou dentro dos próximos {days} dias nas configurações do seu gabinete. Se você não fizer isso, não poderá transferir, sacar ou depositar até que sejam atualizados.',
			idRefinitiv:
				'Qual método de verificação de identidade você gostaria de usar?',
			idRefinitivDesc:
				'Atualizar sua identidade com um documento de identidade emitido pelo governo garante a segurança e a legitimidade da sua conta.',
			idTooltip:
				'Escolha como deseja concluir a verificação de identidade. Você pode escanear o código QR com seu telefone ou abrir uma nova aba em seu computador.  Selecione o método de sua preferência abaixo.',
			cancelModal: 'Tem certeza de que deseja sair?',
			cancelModalDesc:
				'Lembre-se, você deve concluir esta etapa nos próximos {days} dias. Se não o fizer, você não terá acesso às funcionalidades de retirada, depósito e transferência em seu gabinete até que os documentos necessários sejam atualizados.',
			accessRestricted: 'Acesso restrito',
			resubmitDocs: 'Reenviar documento',
			restrictedID:
				'Notamos durante uma verificação aleatória que o documento de identidade fornecido está expirado. Para garantir a segurança da sua conta, bloqueamos temporariamente as funcionalidades de transferência, retirada e depósito.',
			restrictedID2:
				'Carregue um novo documento de identidade agora para restaurar o acesso e continuar desfrutando de uma experiência tranquila em seu gabinete.',
			restrictedPOA:
				'Notamos durante uma verificação aleatória que o comprovante de endereço enviado está expirado. Para garantir a segurança da sua conta, bloqueamos temporariamente as funcionalidades de transferência, retirada e depósito.',
			restrictedPOA2:
				'Carregue um novo comprovante de endereço agora para restaurar o acesso e continuar desfrutando de uma experiência tranquila em seu gabinete.',
			restrictedBoth:
				'Notamos durante uma verificação aleatória que seu documento de identidade e comprovante de endereço enviados estão expirados. Para garantir a segurança da sua conta, bloqueamos temporariamente as funcionalidades de transferência, retirada e depósito.',
			restrictedBoth2:
				'Carregue novos arquivos agora para restaurar o acesso e continuar desfrutando de uma experiência tranquila em seu gabinete.',
		},
	},

	//Aplication Process refinitiv
	appliProcessIDverse: {
		QRdescription: 'Use a câmera do seu telefone para escanear o código QR.',
		IDVerseTitle:
			'Qual método de verificação de identidade você gostaria de usar?',
		IDVerseTitleLatam:
			'Escolha o método de verificação de identidade de sua preferência',
		IDVerseTitleManualDoc:
			'Escolha o método de verificação de identidade de sua preferência',
		IDVerseTitleManualDocTitle: 'Escolha um tipo de documento',
		IDVerseTitleManualDocDesc:
			'Por favor, selecione o tipo de documento que deseja usar para a verificação:',
		IDVerseTitleManualDocMainDesc:
			'O processo de verificação de identidade é essencial para prevenir fraudes e garantir o uso responsável e legal dos nossos serviços. Agradecemos sinceramente a sua cooperação.',
		IDVerseDesc:
			'Para uma experiência mais tranquila, sugerimos concluir esta etapa no seu celular usando uma das opções abaixo:',
		or: 'o',
		verifyOnNewTab: 'Verifique sua identidade em uma nova aba.',
		sendLinkSms: 'Enviar link por SMS',
		verifyPopupConfig:
			'Por favor, certifique-se de que o bloqueador de pop-ups do seu navegador esteja desativado. Para mais informações.',
		clickHere: 'clique aqui',
		alertDetail:
			'Por favor, note que você pode acessar o processo de verificação apenas uma vez por link único. Se precisar acessá-lo novamente, atualize a página e clique no método de verificação desejado.',
		alertDetailMobile:
			'Por favor, note que você pode acessar o processo de verificação apenas uma vez por link único. Para concluir o processo de verificação, atualize a página e clique em `Verificar minha ID`. Se já concluiu, clique em Continuar.',

		//Modal Verify Identity
		modalVerifyTitle: 'Verifique sua identidade',
		btnVerifyID: 'Verificar meu ID',
		modalVerifyDesc1:
			'Para continuar, você deve completar o processo de verificação de identidade.',
		modalVerifyDesc2:
			'Se você já o completou e ainda não consegue continuar, por favor, entre em contato conosco o mais rápido possível.',
		modalVerifyButton: 'Selecione seu método de verificação de identidade',
		//Skip step
		modalSkipTitle: 'Tem certeza de que deseja pular esta etapa?',
		modalSkipDesc1:
			'Você pode pular esta etapa temporariamente e concluí-la mais tarde no seu gabinete de cliente, ou escolher um método de verificação de identidade agora para finalizar o processo.',
		modalSkipDesc2:
			'Lembre-se de que completar esta etapa é necessário para ativar sua conta de trading.',
		btnVerifyAddress: 'Verificar meu endereço',
		btnVerifyIdentity: 'Verificar minha identidade',
		btnSkip: 'Pular por enquanto',
		modalSendSMSChangeNumberTitle: 'Insira um novo número de celular',
		modalSendSMSChangeNumberDesc:
			'Insira o número de celular para onde deseja receber o link de verificação por SMS.',
		modalSendSMSChangeNumberButton: 'Enviar',
		modalSendSMSChangeNumberCancel: 'Cancelar',
		modalSendSMSChangeNumberCheck:
			'Salvar como meu número de celular registrado.',
		modalSendLinkSMSFailedTitle: 'Ocorreu um erro',
		modalSendLinkSMSFailedDesc:
			'Não foi possível enviar o link por SMS. Verifique o número e tente novamente.',
		modalSendLinkSMSFailedButtonCancel: 'Cancelar',
		modalSendLinkSMSFailedButtonChangeNumber: 'Alterar número',
		modalSendLinkSMSTitle: 'Link enviado por SMS',
		modalSendLinkSMSDesc:
			'Um link foi enviado para seu número de celular registrado por SMS. Abra o link no celular e siga as etapas para concluir a verificação de identidade.',
		modalSendLinkSMSButtonReSend: 'Reenviar',
		modalSendLinkSMSButtonOkay: 'OK',
		clickHere: 'Clique aqui',
		or: 'Ou',
		modalSendLinkSMSOptionalNumber: 'Enviar para outro número de celular',
		uploadCurrentDevice:
			'para enviar seu documento a partir do dispositivo atual.',
		retryIn: 'tente novamente em',
		chooseTooltip:
			'Escolha como deseja concluir a verificação de identidade. Você pode escanear o QR code com a câmera do celular, enviar um link por SMS ou continuar no dispositivo atual.',
		sendToDifferentNumber: 'Enviar para outro número de celular',
		chromeInstructions: {
			step1: 'Vá para Configurações',
			step2:
				'Navegue para Privacidade e segurança > Configurações do site > Pop-ups e redirecionamentos',
			step3: "Desative a opção 'Bloquear'",
		},
		safariInstructions: {
			step1: 'Vá para Safari > Preferências',
			step2: 'Selecione Sites > Janelas pop-up',
			step3: 'Ajuste as configurações conforme necessário',
		},
		firefoxInstructions: {
			step1: 'Clique no ícone do menu.',
			step2: 'Vá para Preferências > Privacidade e segurança > Permissões.',
			step3: 'Ajuste as configurações de pop-up conforme necessário.',
		},
		assistanceText: `Se você encontrar alguma dificuldade, por favor, entre em contato conosco para obter assistência`,
		assistanceText2: `entre em contato conosco para obter assistência.`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: 'Conta corporativa ativa',

		//Company details
		companyDetailsTitle: 'Detalhes da empresa',
		nameLabel: 'Nome da empresa',
		namePlaceholder: 'Digite o nome da sua empresa',
		businessTypeLabel: 'Tipo de negócio',
		businessTypePlaceholder: 'Selecione um tipo de negócio',
		companyEmailLabel: 'E-mail da empresa',
		companyEmailPlaceholder: 'Digiteo e-mail corporativo',
		companyEmailTooltip:
			'Solicitamos um e-mail da empresa para garantir uma comunicação segura e verificar a legitimidade das contas corporativas. Isso nos ajuda a manter um ambiente de negociação seguro e confiável para sua empresa.',
		businessDescriptionLabel: 'Descrição da empresa',
		businessDescriptionPlaceholder:
			'Insira uma breve descrição do porte da empresa e dos serviços que ela oferece.',
		businessDescriptionTooltip:
			'Isso nos ajuda a entender as atividades e os propósitos da sua empresa. Fornecer uma descrição clara garante um processo de aprovação de conta tranquilo e nos ajuda a adaptar nossos serviços para atender às necessidades do seu negócio.',

		//Company address
		companyAddressTitle: 'Endereço da empresa',
		companyAddressTitleTooltip: `Refere-se ao país onde sua empresa está localizada principalmente. Informações precisas nos ajudam a personalizar nossos serviços com base em requisitos e regulamentações regionais.
  
		Se o seu país de localização não estiver listado nas opções, lamentamos informar que não podemos oferecer nossos serviços em sua localidade.`,

		//Account ownership
		accountOwnershipTitle: 'Informações de propriedade da conta',
		dateIncorporationLabel: 'Data de incorporação',
		dateIncorporationTooltip:
			'Esta é a data em que sua empresa foi oficialmente registrada. O fornecimento dessa data nos ajuda a verificar o status legal da sua empresa e garante a conformidade com os requisitos regulamentares.',
		countryOfRegistrationLabel: 'País de registro',
		countryOfRegistrationPlaceholder: 'Selecione um país',
		countryOfRegistrationTooltip:
			'Este é o país onde a sua empresa está oficialmente registrada. O fornecimento dessas informações nos ajuda a entender a jurisdição legal de sua empresa, garantindo a conformidade com as regulamentações regionais.',
		marketCapitalizationLabel:
			'Capitalização total de mercado ou patrimônio líquido',
		marketCapitalizationPlaceholder:
			'Informe a capitalização total de mercado de sua empresa',
		marketCapitalizationTooltip:
			'A capitalização total de mercado abrange o valor geral de mercado das ações em circulação de uma empresa, enquanto o patrimônio líquido representa o valor total dos ativos de uma empresa menos seus passivos.',
		isSubsidiaryLabel: 'Se for uma subsidiária, forneça a empresa controladora',
		isSubsidiaryPlaceholder: 'Digite o nome da empresa controladora',
		isIndividualRegularMemberLabel:
			'O indivíduo que está preenchendo este formulário é um membro/sócio regular ou representa os proprietários beneficiários finais da entidade mencionada nesse relacionamento?',

		//Tax residency information
		taxResidencyTitle: 'Declaração de residência fiscal',
		isUSCompanyLabel:
			'A empresa é classificada como uma entidade dos EUA ou residente fiscal dos EUA?',
		taxResidencyContryLabel:
			'A empresa confirma que, para fins fiscais, é residente no seguinte país:',
		taxResidencyContryListLabel: 'País',
		taxResidencyContryListPlaceholder: 'Selecione um país',
		taxResidencyReferenceCodeLabel: 'Código de referência fiscal',
		taxResidencyReferenceCodePlaceholder:
			'Digite seu código de referência fiscal',
		modalRegulationP:
			'Lamentamos. Devido à regulamentação, não podemos fornecer serviços para empresas com sede ou consideradas residentes fiscais no território dos EUA.',

		//Account type and platform information
		accountTypeTitle: 'Tipo de conta',

		// Financial details
		financialDetailsTitle: 'Dados financeiros',
		financialDetailsTooltip:
			'É necessário que você divulgue os detalhes financeiros da sua empresa para tratar dos riscos adequadamente para ambas as partes (a empresa e a Tradeview).',
		companyAnnualIncomeLabel:
			'Qual é a renda anual/volume de negócios total da empresa?',
		companyAnnualIncomeTooltip:
			'A receita anual ou o faturamento total de uma empresa refere-se à receita total gerada por uma organização durante um período específico de tempo, normalmente um ano.',
		companyTotalAssetsLabel: 'Qual é o saldo total de ativos da empresa?',
		companyTotalAssetsTooltip:
			'O saldo de ativos da empresa é o valor das economias, investimentos e propriedades imobiliárias da empresa após a dedução dos compromissos..',
		companyLiquidAssetsLabel: 'Qual é o saldo de ativos líquidos da empresa?',
		companyLiquidAssetsTooltip:
			'Seu saldo de ativos líquidos é a soma de seu caixa, dinheiro, instrumentos de mercado e títulos negociáveis.',
		companyOriginAssetsLabel: 'Qual é a origem do total de ativos da empresa?',
		companySourceFundsLabel: 'Qual é a origem dos depósitos/fundos da empresa?',
		companyPruoseAccountLabel: 'Qual é o objetivo da conta?',
		companyIsConnectedBanktruptcies:
			'A empresa está ligada a falências bancárias?',
		companyIsConnectedBanktruptciesDetailsLabel: 'Detalhes de falências',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'Inclua informações sobre falências associadas à empresa.',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'A empresa é obrigada a divulgar qualquer afiliação a falências para abordar os riscos para ambas as partes (a empresa e a Tradeview). No entanto, fique tranquilo, se a empresa tiver alguma conexão com falência, ainda assim é bem-vinda a prosseguir com o processo de inscrição.',

		//Proof of address
		proofAddressTitle: 'Comprovante de endereço',
		proofAddressDescription:
			'Confirme a localização de sua empresa para garantir a conformidade com os padrões regulatórios.',

		//Company Account Consent
		companyAccountConsentTitle:
			'Obrigado por compartilhar seus detalhes corporativos conosco.  Vamos prosseguir!',
		companyAccountConsentDescription1:
			'Agora, vamos preencher as informações do titular da conta. Você pode editar os detalhes fornecidos a qualquer momento usando a lista de progresso no lado direito da tela. Basta clicar no ícone de lápis ao lado das informações que você gostaria de editar.',
		companyAccountConsentDescription2:
			'Observe que, além dos documentos de identificação com foto emitidos pelo governo e do comprovante de residência, você pode carregar os documentos necessários conforme sua conveniência - agora ou mais tarde, quando solicitado.',
		companyAccountConsentDocumentsTitle:
			'Antes de começar, verifique se você tem os documentos abaixo prontos para serem carregados:',
		companyAccountConsentDocumentsList1:
			'Documento de identidade com foto emitido pelo governo do titular da conta',
		companyAccountConsentDocumentsList2:
			'Comprovante de residência do titular da conta',
		applicationFormAccountCheck:
			'* Concordo em permitir que a Tradeview Financial Markets S.A.C. verifique eletronicamente minha identidade fornecendo minhas informações pessoais, inclusive documentos de identidade. Essas informações serão compartilhadas com um provedor de serviços de verificação de identidade confiável para confirmar sua exatidão e compará-las com os dados que eles possuem ou obtêm de outras fontes confiáveis.',

		//Company Consent
		companyConsentTitle:
			'Obrigado por seu interesse! Vamos começar sua inscrição',
		companyConsentDescription:
			'Para configurar sua conta conjunta, precisamos de algumas informações suas.',
		companyConsentDocumentsTitle:
			'Tenha os seguintes documentos em mãos antes de começar:',
		companyConsentDocumentsOfCompanyTitle: 'Company',
		companyConsentDocumentsList1: 'Certificado de registro da empresa',
		companyConsentDocumentsList2: 'Comprovante de endereço da empresa',
		companyConsentDocumentsList3: 'Extrato bancário da empresa',
		companyConsentDocumentsList4: 'Demonstrativo financeiro da empresa',
		companyConsentDocumentsList5: 'Certificado fiscal da empresa',
		companyConsentDocumentsList6: 'Estrutura de propriedade da empresa',
		companyConsentDocumentsList7: 'Relatório anual da empresa',
		companyConsentDocumentsOfAccountHolderTitle: 'Titular da conta',
		companyConsentDocumentsOfAccountHolderList1: 'Plano de negócios da empresa',
		companyConsentDocumentsOfAccountHolderList2: 'Licença comercial da empresa',
		companyConsentDocumentsOfShareholderTitle: 'UBO/Acionista',
		companyConsentDocumentsOfShareholderList1:
			'Acordo de acionistas da empresa',
		companyConsentDocumentsOfShareholderList2:
			'Certificado de acionista da empresa',
		companyConsentAdditionalInfoDescription:
			'Você pode fazer o upload dos documentos que tem à mão; apenas um comprovante de endereço e identificação são necessários para iniciar o processo. Todos os outros documentos podem ser enviados ou enviados por e-mail posteriormente.',
		applicationFormConsentCheck:
			'* Concordo em permitir que a Tradeview Financial Markets S.A.C. verifique eletronicamente minha identidade fornecendo minhas informações pessoais, inclusive documentos de identidade. Essas informações serão compartilhadas com um provedor de serviços de verificação de identidade confiável para confirmar sua exatidão e compará-las com os dados que eles possuem ou obtêm de outras fontes confiáveis.',

		//Account holder details
		accountHolderDetailsTitle: 'Informações sobre o titular da conta',
		accountHolderDetailsTooltip:
			'O titular da conta é o principal indivíduo responsável pelo gerenciamento da conta corporativa. Essa pessoa executa negociações, toma decisões sobre a conta e tem autoridade para adicionar ou remover acionistas. Certifique-se de que os detalhes do titular da conta representem com precisão o principal tomador de decisões para suas atividades corporativas.',

		//Account holder address
		accountHolderAddressTitle: 'Endereço do titular da conta',
		accountHolderAddressTooltip:
			'Forneça as informações de residência fiscal do titular da conta, o indivíduo que gerencia a conta corporativa. Essas informações se referem ao titular da conta, não à empresa em si..',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'Forneça as informações de residência fiscal do titular da conta, o indivíduo que gerencia a conta corporativa. Essas informações se referem ao titular da conta, não à empresa em si.',
		accountHolderTaxResidencyModalDescription:
			'Lamentamos. Devido à regulamentação, não podemos prestar serviços para empresas sediadas ou pessoas que residem no território dos EUA. ',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'Selecione a opção que melhor representa sua experiência individual de negociação em Forex, ações, futuros, derivativos ou CFDs.',

		//Shareholder consent
		shareholderConsentTitle:
			'Ótimo! As informações do titular da conta já estão completas. Não perca o ritmo.',
		shareholderConsentDescription1:
			'Estamos quase terminando. Só precisamos inserir as informações dos acionistas.',
		shareholderConsentDescription2:
			'Se necessário, você pode editar os detalhes fornecidos anteriormente a qualquer momento usando a lista de progresso no lado direito da tela. Basta clicar no ícone de lápis ao lado das informações que você deseja editar.',
		shareholderConsentDescription3:
			'Lembre-se de que, além dos documentos de identificação com foto emitidos pelo governo e do comprovante de residência, você pode carregar os documentos necessários conforme sua conveniência - agora ou mais tarde, quando solicitado.',
		companyConsentConsentDocumentsTitle:
			'Antes de começar, certifique-se de que você ou os acionistas têm os seguintes documentos obrigatórios prontos:',
		companyConsentConsentDescription1:
			'Estamos quase lá! Basta inserir as informações dos acionistas para concluir o processo.',
		companyConsentConsentDescription2:
			'Se necessário, você pode editar qualquer detalhe que tenha inserido anteriormente clicando no ícone de lápis na coluna da direita.',
		shareholderConsentDocumentsTitle:
			'Antes de começar, cada acionista deve preparar os seguintes documentos obrigatórios:',
		shareholderConsentDocumentsList1:
			'Documento de identificação com foto emitido pelo governo do acionista',
		shareholderConsentDocumentsList2: 'Comprovante de residência do acionista',
		shareholderConsentDocumentsList3: 'Assinatura digital',
		shareholderConsentCheck:
			'*Concordo em permitir que a Tradeview Financial Markets S.A.C. verifique eletronicamente minha identidade fornecendo minhas informações pessoais, inclusive documentos de identidade. Essas informações serão compartilhadas com um provedor de serviços de verificação de identidade confiável para confirmar sua exatidão e compará-las com os dados que eles possuem ou obtêm de outras fontes confiáveis.',

		//Application Submition
		applicationSubmitionTitle: 'Submissão da aplicação',
		applicationSubmitionDescription1:
			'Sua solicitação de conta corporativa está quase pronta! Agradecemos o esforço feito no preenchimento da solicitação. ',

		applicationSubmitedTitle:
			'Solicitação corporativa enviada: Revisão em andamento',
		applicationSubmitedDescription1:
			'Obrigado por enviar sua solicitação de conta corporativa. Sua solicitação está sendo analisada e será verificada em breve.',
		applicationSubmitedDescription2:
			'Nossa equipe de operações entrará em contato com você caso opte por não carregar nenhum dos documentos solicitados durante o preenchimento das informações.',
		//Global
		selectOption: 'Selecione uma opção',
		accountOwnershipTooltip:
			'Refere-se ao país onde sua empresa está localizada principalmente. Informações precisas nos ajudam a personalizar nossos serviços com base em requisitos e regulamentações regionais. Se o seu país de localização não estiver listado nas opções, lamentamos informar que não podemos oferecer nossos serviços em sua localidade.',

		//Progress
		companyInformation: 'Informações da Empresa',
		companyAddressDetails: 'Detalhes do endereço da empresa',
		companyOwnershipDetails: 'Detalhes da propriedade da empresa',
		companyDocuments: 'Documentos da empresa',
		accountConsent: 'Consentimento da conta',
		tradingExperience: 'Experiência de negociação',
		accountInformation: 'Informação da conta',
		tradingExperience: 'Experiência de negociação',
		IDVerification: 'Verificação de identidade',
		shareholderInformation: 'Informações do acionista',
		shareholderConsent: 'Consentimento dos acionistas',
		finish: 'Terminar',
		addressDetails: 'Detalhes do Endereço',

		share: 'Compartilhar',

		//Shareholder consent
		welcomeShareholderConsentTitle:
			'Pronto para criar sua conta corporativa? Vamos começar sua inscrição.',
		welcomeShareholderConsentDescription1:
			'Para configurar sua conta conjunta, precisamos de algumas informações suas.',
		shareholderConsentDocumentsTitle:
			'Antes de começar, prepare os seguintes documentos:',
		welcomeShareholderConsentDocumentsList1:
			'Documento de identidade com foto emitido pelo governo',
		welcomeShareholderConsentDocumentsList2: 'Comprovante de residência',
	},

	//disclaimer
	disclaimer: {
		title: 'Isenção de responsabilidade',
		secure1: 'SEGURA',
		secure2: 'CRIPTOGRAFIA SSLN',
		secure3: '',
		term: 'Termos e condições',
		privacy: 'Política de Privacidade',
		aml: 'Política de AML',
		withdrawal: 'Política de Retirada',
		refund: 'Política de Reembolso',
		risk: 'Divulgação de riscos',
		pt: {
			description:
				'Os serviços e produtos oferecidos pela Tradeview Financial Markets S.A.C. não estão sendo oferecidos nos Estados Unidos (EUA) e não estão sendo oferecidos a pessoas dos EUA, conforme definido pela legislação dos EUA. As informações contidas neste site não são direcionadas a residentes de qualquer país onde a negociação de FX e/ou CFDs seja restrita ou proibida por leis ou regulamentos locais. Os CFDs são instrumentos complexos e apresentam um alto risco de perda rápida de dinheiro devido à alavancagem. Entre 74% e 89% das contas de investidores de varejo perdem dinheiro ao negociar CFDs. Você deve considerar se entende como os CFDs funcionam e se pode se dar ao luxo de correr o alto risco de perder seu dinheiro.',
		},
		default: {
			description:
				'Os serviços e produtos oferecidos pela Tradeview Markets não estão sendo oferecidos dentro dos Estados Unidos (EUA) e não estão sendo oferecidos a Pessoas dos EUA, conforme definido pela lei dos EUA. As informações neste site não são direcionadas a residentes de qualquer país onde a negociação de FX e/ou CFDs seja restrita ou proibida por leis ou regulamentos locais. Os CFDs são instrumentos complexos e vêm com um alto risco de perder dinheiro rapidamente devido à alavancagem. Entre 74% e 89% das contas de investidores de varejo perdem dinheiro ao negociar CFDs. Você deve considerar se entende como os CFDs funcionam e se pode arcar com o alto risco de perder seu dinheiro.',
		},
		ltd: {
			description:
				'Os serviços e produtos oferecidos pela Tradeview Ltd. não estão sendo oferecidos dentro dos Estados Unidos (EUA) e não estão sendo oferecidos a Pessoas dos EUA, conforme definido pela lei dos EUA. As informações neste site não são direcionadas a residentes de qualquer país onde a negociação de FX e/ou CFDs seja restrita ou proibida por leis ou regulamentos locais. Os CFDs são instrumentos complexos e vêm com um alto risco de perder dinheiro rapidamente devido à alavancagem. Entre 74% e 89% das contas de investidores de varejo perdem dinheiro ao negociar CFDs. Você deve considerar se entende como os CFDs funcionam e se pode arcar com o alto risco de perder seu dinheiro.',
		},
		latam: {
			description:
				'Os serviços e produtos oferecidos pela Tradeview Financial Markets S.A.C. não estão sendo oferecidos dentro dos Estados Unidos (EUA) e não estão sendo oferecidos a Pessoas dos EUA, conforme definido pela lei dos EUA. As informações neste site não são direcionadas a residentes de qualquer país onde a negociação de FX e/ou CFDs seja restrita ou proibida por leis ou regulamentos locais. Os CFDs são instrumentos complexos e vêm com um alto risco de perder dinheiro rapidamente devido à alavancagem. Entre 74% e 89% das contas de investidores de varejo perdem dinheiro ao negociar CFDs. Você deve considerar se entende como os CFDs funcionam e se pode arcar com o alto risco de perder seu dinheiro.',
		},
		mena: {
			description:
				'Os serviços e produtos oferecidos pela Tradeview Financial Markets S.A.C. não estão sendo oferecidos dentro dos Estados Unidos (EUA) e não estão sendo oferecidos a Pessoas dos EUA, conforme definido pela lei dos EUA. As informações neste site não são direcionadas a residentes de qualquer país onde a negociação de FX e/ou CFDs seja restrita ou proibida por leis ou regulamentos locais. Os CFDs são instrumentos complexos e vêm com um alto risco de perder dinheiro rapidamente devido à alavancagem. Entre 74% e 89% das contas de investidores de varejo perdem dinheiro ao negociar CFDs. Você deve considerar se entende como os CFDs funcionam e se pode arcar com o alto risco de perder seu dinheiro.',
		},
	},

	//modal
	modal: {
		error: 'Não é possível continuar com sua solicitação',
		description:
			'Lamentamos. Devido à regulamentação, não podemos fornecer serviços a pessoas que residem no território dos EUA. ',
		thank: 'Obrigado por seu interesse em se juntar à Tradeview.',
		btnRegulation: 'Visite a página de regulamentação',
	},

	//tooltips
	tooltips: {
		signature1:
			'Escolha como deseja carregar sua assinatura. Você pode usar nosso recurso de upload de assinatura ou desenhar sua assinatura diretamente usando nossa ferramenta interativa. Selecione seu método preferido abaixo.',
		sourceAccount: 'A conta da qual os fundos serão retirados.',
		sourceAccountTransfer: 'A conta da qual os fundos serão transferidos.',
		withdrawCurrency:
			'A moeda é a principal forma de pagamento que você usará em sua conta. Ela é representada usando as seguintes abreviações: <br><br> USD: Dólar americano <br> EUR: Euro <br> GBP: Libra da Grã-Bretanha',
		currencyUSD: 'USD: Dólar americano',
		currencyEUR: 'EUR: Euro',
		currencyJYP: 'JPY: Iene japonês',
		currencyCAD: 'CAD: Dólar canadense',
		currencyGBP: 'GBP: Libra da Grã-Bretanha',
		targetAccount: 'A conta que receberá os fundos transferidos.',
		digitalWallets:
			'Para sua conveniência, aceitamos uma ampla seleção de opções de carteira eletrônica. Observe que as taxas podem variar dependendo da fonte de recursos que você escolher.',
		wireTransfers:
			'Com esse método de depósito, você precisará selecionar seu banco, fornecer as informações necessárias, iniciar a transferência e seus fundos estarão disponíveis logo após a validação do seu corretor.',
		cardTransfers:
			'Aceitamos Visa, Mastercard e Apple Pay para seus depósitos com cartão de crédito.',
		currencyUphold: `A moeda é a principal forma de pagamento que você usará em sua conta. Ela é representada usando as seguintes abreviações:<br/>USD: Dólar americano <br/>EUR: Euro <br/>JPY: Iene japonês <br/>CAD: Dólar canadense <br/>AUD: Dólar australiano <br/>CHF: Franco Suíço <br/>GBP: Libra da Grã-Bretanha <br/>MXN: Mexico Peso <br/>ZAR: Rand da África do Sul`,
		currencyType:
			'A moeda é a principal forma de pagamento que você usará em sua conta.',
		leverageTM:
			'A alavancagem permite que você controle posições maiores do que o seu capital inicial permite, normalmente expressas em proporções como 50:1 ou 100:1, mostrando as ações que você pode controlar em comparação com seu próprio depósito.',
		demoXleverage: 'X-Leverage: 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: 'Stock: 1:1',
		notSureAccount:
			'Não tem certeza de qual tipo de conta escolher? Você pode revisá-los ',
	},

	//register
	register: {
		goBack: 'Voltar atrás',
		titleRegister: 'Registro de Conta',
		AccountDesc:
			'Bem-vindo ao nosso portal de trading! Escolha entre uma conta Demo ou Real para iniciar sua jornada de trading e descobrir a diferença da Tradeview.',
		AccountChoose: 'Que tipo de conta você gostaria de criar?',
		dinamicDescLive:
			'Ainda não está pronto para uma conta real? <spam>Crie uma conta Demo.</spam>',
		dinamicDescDemo: 'Quer operar ao vivo? <spam>Crie uma conta Real</spam>',
		getYour: 'Comece a negociar agora!',
		or: 'Ou registre-se aqui:',
		email: 'E-mail',
		secure: 'Criar senha',
		confirmPassword: 'Confirmar senha',
		disclaimer:
			"Isenção de responsabilidade: Antes de abrir uma conta, é nossa obrigação na Tradeview Financial Markets S.A.C. ('Tradeview') garantir que Você ou a(s) pessoa(s) indicada(s) para negociar em seu nome tenha(m) o conhecimento e a experiência necessários em CFD e instrumentos financeiros relacionados. Também é nossa obrigação cumprir com as obrigações de AML e CFT. Nesse sentido, solicitamos que você forneça informações precisas, completas e factuais, conforme solicitado, de acordo com esta solicitação e para que possamos cumprir as obrigações acima. Com base nessas informações, poderemos determinar adequadamente se os serviços de investimento relacionados ao(s) instrumento(s) financeiro(s) são apropriados para Você. Todas as seções precisam ser preenchidas. Para obter mais detalhes, consulte nosso Contrato com o Cliente. Para residentes da União Europeia: Ao marcar a caixa abaixo, você confirma que não foi solicitado pela Tradeview ou por qualquer indivíduo associado à Tradeview a abrir uma conta na entidade selecionada.",
		byTicking:
			'Ao marcar esta caixa, você concorda com a isenção de responsabilidade acima.',
		getstarted: 'Continuar',
		messageFooter1: 'Os serviços e produtos oferecidos pela ',
		messageFooter2:
			' não estão sendo oferecidos nos Estados Unidos (EUA) e não estão sendo oferecidos a pessoas dos EUA, conforme definido pela legislação dos EUA. As informações contidas neste site não são direcionadas a residentes de qualquer país onde a negociação de FX e/ou CFDs seja restrita ou proibida por leis ou regulamentos locais. Os CFDs são instrumentos complexos e apresentam um alto risco de perda rápida de dinheiro devido à alavancagem. Entre 74% e 89% das contas de investidores de varejo perdem dinheiro ao negociar CFDs. Você deve considerar se entende como os CFDs funcionam e se pode se dar ao luxo de correr o alto risco de perder seu dinheiro.',
		client: 'Client Cabinet',
		instructionstitle1: 'Economize tempo e esforço!',
		instructionstitle2: 'Uma plataforma para cada',
		instructionstitle3: 'necessidade que você tem',
		options1f: 'Regulamentadas',
		options1l: 'e seguras ',
		options2f: 'Personalized',
		options2l: 'assistance',
		options3f: 'Liquidez',
		options3l: 'inigualável',
		haveAccount: 'Você tem uma conta? ',
		signUp: ' Login',
		newCode: 'Um código único foi enviado para',
		tryEgain:
			'Não é possível reenviar seu código no momento. Por favor, tente novamente.',
		invalidEmail: 'Formato inválido. Por favor, tente novamente.',
		passwordRequired: 'Este campo é obrigatório. Por favor, preencha-o.',
		invalidPassword:
			'A senha deve ter pelo menos 8 caracteres e incluir pelo menos uma letra minúscula, uma letra maiúscula, um número e um caractere especial.',
		confirmPasswordRequired: 'Este campo é obrigatório. Por favor, preencha-o.',
		passwordsDoNotMatch: 'A senha não corresponde. Tente novamenten',
		errorDisclaimer:
			'Marque a caixa de seleção de confirmação para prosseguir.',
		firstNameError: 'Este campo é obrigatório. Por favor, preencha-o.',
		typeAccountError: 'Selecione um tipo de conta',
		invalidName:
			'Seu primeiro nome não pode ter números ou símbolos. Por favor, tente novamente.',
		invalidLastName:
			'Seu sobrenome não pode ter números ou símbolos. Tente novamente.',
		mfaCode: 'Digite o código MFA',
		startDemo: 'Obtenha sua conta de demonstração gratuita agora!',
		orRegister: 'Ou registre-se aqui:',
		verificationCode: 'Código de verificação',
		didntCode: 'Não recebeu nenhum código?',
		yourEmail: 'Seu e-mail',
		firstName: 'Seu primeiro nome',
		lastName: 'Sobrenome',
		accountType: 'Tipo de conta',
		accountCategory: 'Categoria da conta:',
		accountCategoryPlaceholder: 'Selecione uma categoria de conta',
		accountCategoryTooltip: `<strong>Conta individual: </strong>  </br> Selecione essa opção se você for um titular de uma única conta. </br></br> <strong>Joint Account (Conta conjunta): </strong>  </br> Escolha essa opção se estiver abrindo uma conta com outra pessoa, como cônjuge ou parceiro de negócios.</br></br> <strong>Corporate Account (Conta corporativa): </strong> </br> Escolha essa opção se estiver representando uma entidade, empresa ou organização.`,
		entity: 'Entidade:',
		entityPLaceholder: 'Selecione uma entidade',
		entityTooltip:
			'Seguimos padrões financeiros rigorosos em todas as jurisdições em que operamos. Para obter mais informações, clique aqui.',
		accountRegis: 'Registro de conta',
		changeRegion: 'Mudar para a entidade da minha região',
		liveIndividual: 'Conta individual real </br> Comece a operar agora!',
		jointIndividual: 'Conta conjunta real </br> Comece a operar agora!',
		corporateIndividual: 'Conta corporativa real </br> Comece a operar agora!',
		entityText:
			'Você está prestes a selecionar para sua conta uma entidade que está estabelecida e é regulamentada em uma região diferente do país de residência que você selecionou.',
		entity: 'Entity:',
		entityPLaceholder: 'Selecione uma entidade',
		entityTooltip:
			'Seguimos padrões financeiros rigorosos em todas as jurisdições em que operamos. Para obter mais informações, clique aqui.',
		accountRegis: 'Registro de conta',
		countryTooltip:
			'Se o seu país de residência não estiver listado nas opções, lamentamos informar que não podemos oferecer nossos serviços na sua localização.',
		checkRegis:
			'Ao marcar esta caixa, reconheço que não fui solicitado pela Tradeview ou por qualquer indivíduo associado à Tradeview para mudar de entidade.',
		entityTextEu: `O site que você está visitando agora é operado pela uma entidade que não está estabelecida na União Europeia ou regulamentada por uma Autoridade Nacional Competente da UE.<br><br>  Ao clicar em 'Continuar', você está confirmando que você não foi solicitado pela Tradeview ou por qualquer indivíduo associado à Tradeview a mudar de entidade.  <br><br> Para ser direcionado para a entidade regulamentada pela União Europeia, Tradeview Europe Ltd, clique em Mudar para a entidade da minha região". A Tradeview Europe Ltd. é regulamentada pela MFSA, que é adequada para sua jurisdição.`,
		entitiesTitle:
			'Entidades internacionais que comercializam sob a nossa marca:',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>Regulado pela Autoridade Monetária das Ilhas Cayman (CIMA) e opera sob as Leis das Ilhas Cayman (SIBL).</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (Global)</b> </li> </ul> <p>Registrada na SUNARP, opera sob a Lei Geral das Empresas (LGS)</p><br> <ul> <li> <b>Tradeview Europe Ltd.</b> </li> </ul> <p>Regulado pela Autoridade de Serviços Financeiros de Malta (MFSA), membro da EBA, ESMA e IOSCO.</p>`,
		entitiesDescEu: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>Regulated by the Cayman Islands Monetary Authority (CIMA) and operates under the Cayman Islands Laws (SIBL)</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (Global)</b> </li> </ul> <p>Registered with SUNARP, operates under the General Law of Companies (LGS).</p> <br> <ul> <li> <b>TVM Global Ltd.</b> </li> </ul> <p>Regulated by the Labuan Financial Services Authority (FSA), licensed under Labuan laws.</p> `,
		individual: 'Individual',
		joint: 'Conjunta',
		corporate: 'Corporativa',
	},

	'reset-password': {
		instructionstitle1: 'Economize tempo e esforço!',
		instructionstitle2: 'Uma plataforma para cada',
		instructionstitle3: 'necessidade que você tem',
		title: 'Definir uma nova senha',
		label1: 'Nova senha',
		label2: 'Confirmar senha',
		options1f: 'Regulamentadas',
		options1l: 'e seguras',
		options2f: 'Personalizado',
		options2l: 'Assistência',
		options3f: 'Incomparável',
		options3l: 'Liquidez',
	},

	//Calendar
	calendar: {
		title: 'Calendário',
	},

	//application process
	application: {
		optional: '(opcional)',
		ifApplicable: '(se aplicável)',
		jobTitleL: 'Título do trabalho',
		jobTitleP: 'Digite o título do seu trabalho',
		emplymentAditionalDetails: 'Informações adicionais',
		taxResTitle: 'Sua declaração de residência fiscal',
		taxResPurposes:
			'Você é cidadão americano ou residente nos EUA para fins fiscais?',
		taxResHereby:
			'Confirmo que sou, para fins fiscais, residente no seguinte país:',
		taxResCountryL: 'País',
		taxResCountryP: 'Selecione um país',
		taxResMarketL: 'Código de referência fiscal',
		jobTitleL: 'Título do cargo',
		jobTitleP: 'Insira o título do seu cargo:',
		taxResMarketP: 'Digite seu código de referência fiscal',
		taxResMarketTM:
			"Seu código de referência fiscal pode consistir em uma combinação de letras e números, mas também pode ser totalmente numérico. Fique tranquilo, suas informações estão seguras conosco. Somos obrigados a solicitar essas informações de acordo com os padrões de relatório da OCDE. Você pode saber mais sobre isso<a href='https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/' target='_blank'>aqui</a>",
		taxResPoliticalL:
			'Você é uma pessoa politicamente exposta (PEP), parente próximo ou associado de uma PEP?',
		taxResPoliticalTM:
			'Uma PEP (Pessoa Politicamente Exposta) é uma pessoa que ocupa ou ocupou um cargo público de destaque, com possíveis implicações para a avaliação de riscos financeiros.',
		taxResStatusL:
			'Qual é o seu status de PEP ou como você está relacionado a uma PEP?',
		taxResStatusP:
			'Forneça-nos os detalhes de seu status de PEP ou de seu relacionamento.',
		taxResStatusTM:
			'Você é obrigado a divulgar seu status de PEP ou quaisquer conexões relacionadas para tratar dos riscos adequadamente para ambas as partes (você e a Tradeview). No entanto, tenha certeza de que, se você for um PEP ou tiver qualquer associação com um, ainda assim poderá prosseguir com o processo de inscrição..',
		accountTypeH: 'Seu tipo de conta',
		accountTypeD:
			'Depois de criar sua primeira conta Tradeview, você pode facilmente abrir mais contas para diferentes ativos financeiros sem a necessidade de preencher todo o formulário novamente.',
		tradingMarketL: 'Mercado de negociação',
		tradingMarketP: 'Selecionar mercado',
		tradingMarketTM:
			"Um mercado de negociação é o mercado ou a bolsa onde um ativo ou instrumento é listado ou cotado para negociação. <br><br> Não tem certeza de qual mercado escolher? Você pode analisá-los <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>aqui</a>",
		currencyTypeL: 'Tipo de moeda',
		currencyTypeP: 'Selecione um tipo de moeda',
		currencyTypeTM:
			'A moeda é a principal forma de pagamento que você usará em sua conta. Ela é representada usando as seguintes abreviações:<br><br>USD: Dólar americano <br> EUR: Euro <br> JPY: Iene japonês <br> CAD: Dólar canadense <br> AUD: Dólar australiano <br> CHF: Franco suíço <br> GBP: GBP: Libra da Grã-Bretanha <br> MXN: Peso mexicano',
		platformL: 'Plataforma',
		platformP: 'Selecione a plataforma',
		platformTM:
			"Uma plataforma é um sistema de software oferecido para operar ativos ou instrumentos. <br><br> Não tem certeza de qual plataforma escolher? Você pode analisá-las <a href='https://www.tvmarkets.com/trading/platforms' target='_blank'>aqui</a>",
		accountTypeL: 'Tipo de conta',
		accountTypeP: 'Selecione o tipo de conta',
		accountTypeTM:
			"O tipo de conta permite que você selecione a alavancagem que pode obter em sua conta <br><br> X-Leverage: 1:400<br> ILC: 1:200<br> Stock: 1:1 <br><br> Não tem certeza de qual tipo de conta escolher? Você pode analisá-los <a href='https://www.tvmarkets.com/trading/accounts' target='_blank'>aqui</a>",
		emplymentDetailsH: 'Seus detalhes de emprego',
		employmentStatusL: 'Status do emprego',
		employmentStatusP: 'Selecione um status',
		employerL: 'Empregador',
		employerP: 'Digite o nome de seu empregador',
		occupationL: 'Ocupação',
		occupationP: 'Digite sua ocupação',
		industryL: 'Setor',
		industryP: 'Selecione a natureza de seu negócio',
		industryTM:
			'O setor descreve as características e atividades fundamentais da empresa em que você trabalha.',
		employmentTypeL: 'Tipo de emprego',
		employmentTypeP: 'Selecione um tipo de emprego',
		employmentTypeTM:
			'O tipo de emprego descreve as características e condições fundamentais que definem seu arranjo de trabalho ou status de emprego',
		employmentAddressL: 'Endereço do empregador',
		employmentAddressP: 'Digite o endereço de seu empregador',
		employerCountryL: 'País do empregador',
		employerCountryP: 'Selecione um país',
		employerProvinceL: 'Província do empregador',
		employerProvinceP: 'Selecione uma província',
		employerCityL: 'Cidade do empregador',
		employerCityP: 'Selecione uma cidade',
		employerZipL: 'CEP/código postal do empregador',
		employerZipP: 'Digite o código postal de seu empregador',
		businessTypeL: 'Tipo de negócio',
		businessTypeP: 'Selecione um tipo de negócio',
		businessTypeTM:
			'Os tipos de negócios referem-se às várias estruturas e formas legais que as organizações ou empresas podem assumir quando operam no mundo dos negócios.',
		businessCountryL: 'País da empresa',
		businessCountryP: 'Selecione um país',
		businessProvinceL: 'Província da empresa',
		businessProvinceP: 'Selecione uma província',
		businessCityL: 'Cidade da empresa',
		businessCityP: 'Selecione uma cidade',
		businessLocationL: 'Local da empresa',
		businessLocationP: 'Digite seu endereço comercial',
		businessNameL: 'Nome da empresa',
		businessNameP: 'Digite o nome de sua empresa',
		businessWebL: 'Site da empresa',
		businessWebP: 'Digite a url do site de sua empresa',
		businessIndustryL: 'Setor',
		businessIndustryP: 'Selecione a natureza de seu negócio',
		businessIndustryTM:
			'O setor descreve as características e atividades fundamentais da empresa em que você trabalha.',
		financialDetailsH: 'Seus dados financeiros',
		annualIncomeL: 'Qual é a sua renda anual/volume total de negócios?',
		totalAssetsL: 'Qual é o saldo total de seus ativos?',
		totalAssetsTM:
			'Seu saldo de ativos é o valor de suas economias, investimentos e propriedades imobiliárias após a dedução dos compromissos.',
		liquidAssetsL: 'Qual é o saldo de seus ativos líquidos?',
		liquidAssetsTM:
			'Seu saldo de ativos líquidos é a soma de seu caixa, dinheiro, instrumentos de mercado e títulos negociáveis.',
		tradeAnnuallyL: 'Quanto você planeja investir/negociar anualmente?',
		originAssetsL: 'Qual é a origem de seus ativos totais?',
		originDepositsL: 'Qual é a origem de seus depósitos/fundos?',
		purposeAccountL: 'Qual é o objetivo da conta?',
		bankruptciesDetailsL: 'Detalhes de falências',
		bankruptciesDetailsP:
			'Adicione informações sobre falências às quais você está ligado',
		bankruptciesDetailsTM:
			'É necessário que você divulgue quaisquer afiliações a falências para tratar dos riscos para ambas as partes (você e a Tradeview).<br><br> No entanto, tenha certeza de que, se estiver ligado a alguma falência, você ainda poderá prosseguir com o processo de inscrição.',
		bankruptciesConnetL: 'Você está ligado a falências?',
		tradingExperienceH: 'Sua experiência de negociação',
		tradingExperienceD:
			'Selecione a opção que melhor representa sua experiência de negociação em Forex, ações, futuros, derivativos ou CFDs.',
		tradingExperienceDMENA:
			'Selecione a opção que melhor representa sua experiência negociando Forex, Ações, Derivativos ou CFDs.',
		tradingExperienceTM:
			'Perguntamos sobre sua experiência de negociação para nos ajudar a fornecer suporte personalizado, orientação e uma experiência de negociação ideal, seja você um operador experiente ou apenas começando.',
		yearsTradingL: 'Há quantos anos você está negociando?',
		yearsTradingP: 'Selecione uma opção',
		tradingVolumenL: 'Qual é o seu volume de negociação?',
		tradingVolumenP: 'Selecione uma opção',
		oftenTradeL: 'Com que frequência você negocia?',
		oftenTradeP: 'Selecione uma opção',
		identityH: 'Sua verificação de identidade',
		identityD:
			'A confirmação de sua identidade com um documento de identidade emitido pelo governo garante a segurança e a legitimidade de sua conta.',
		identityDLatam:
			'Para uma experiência mais tranquila, sugerimos que complete esta etapa no seu celular usando o código QR abaixo.Você precisará de um dos seguintes documentos para realizar a verificação:',
		idDocumentL: 'Documento de identidade',
		idDocumentP: 'Selecione um tipo de documento',
		idDocumentTM:
			'Tipo de documento refere-se aos tipos de identificação que você pode usar para confirmar sua identidade para uma experiência de negociação segura. Aceitamos os seguintes documentos: <br> <br> Passaporte (sugerido)<br> Carteira de identidade<br>Autorização de residência<br> Autorização de residência',
		idDocumentUploadL: 'Upload de documentos',
		idDocumentUploadTM:
			'Certifique-se de que as informações e imagens do arquivo sejam claras e compreensíveis.',
		idDocumentFrontL: 'Parte frontal',
		idDocumentFrontTM:
			'A frente de sua identificação exibe sua foto, nome completo e número de identificação.',
		idDocumentBackL: 'Verso',
		idDocumentBackTM:
			'O verso de seu documento de identidade contém informações adicionais, como seu endereço ou outros detalhes relevantes.',
		proofResidenceH: 'Seu comprovante de residência',
		proofResidenceD:
			'Confirme sua localização para garantir a conformidade com os padrões regulatórios.',
		proofResidenceL: 'Documento de comprovação de residência',
		proofResidenceP: 'Selecione um tipo de documento',
		proofResidenceTM:
			'Para verificar seu endereço, forneça um destes documentos:<br><br>  • Conta de serviços públicos  <br>  • Extrato bancário <br> • Certificado de residência   <br><br>   As contas aceitas incluem:   <br>• Gás    <br>• Eletricidade  <br>  • Água  <br>  • Telefone fixo  <br>  • Internet (se conectada à residência)<br>  • Cabo (se conectado à residência) <br> • Extrato bancário ou de cartão de crédito (com histórico de transações)<br>    Não aceitamos contas de telefone celular ou extratos bancários que mostrem grandes depósitos em dinheiro.',
		proofUploadL: 'Carregar documentos',
		proofUploadTM:
			'Certifique-se de que o documento: <br><br> • Não tenha mais de 3 meses <br>• Inclua seu nome <br>• Tenha um endereço que corresponda ao que consta em sua inscrição <br>• Não seja uma captura de tela <br>• Não foi cortado<br>• Não tem informações bloqueadas/mascaradas <br>• Tem um idioma traduzível.',
		addressDetail: 'Endereço',
		financialDetailsTM:
			'É necessário que você divulgue seus dados financeiros para tratar dos riscos adequadamente para ambas as partes (você e a Tradeview).',
		acknowledgementH: 'Reconhecimento',
		acknowledgementCheck:
			'Ao marcar esta caixa, reconheço que li, compreendi e concordo com todas as informações contidas nos documentos listados acima.',
		signatureH: 'Assinatura',
		signatureP1:
			'Ao assinar abaixo, eu reconheço e concordo com os documentos listados na etapa anterior deste processo.',
		signatureP2:
			'Além disso, também reconheço e concordo, sob pena de perjúrio, que todas as informações fornecidas na solicitação são verdadeiras e precisas e que todos os depósitos em minha conta, independentemente da fonte de origem, do tipo de moeda ou do método de depósito, não são produtos de atividades criminosas ou ilegais e são derivados de fontes legítimas.',
		signatureMethod: 'Qual método de assinatura você gostaria de usar?',
		signatureDraw: 'Desenhar assinatura',
		signatureUpload: 'Carregar assinatura',
		signatureTM:
			'Escolha como deseja carregar sua assinatura. Você pode usar nosso recurso de upload de assinatura ou desenhar sua assinatura diretamente usando nossa ferramenta interativa. Selecione seu método preferido abaixo.',
		signatureAD: 'Assinatura autorizada do cliente, assine acima',
		additionalRiskH: 'Divulgação de risco adicional',
		additionalRiskD1:
			'As informações fornecidas em sua solicitação de conta indicam que você não atende às diretrizes da Tradeview Financial Markets S.A.C. para abrir uma conta de negociação por um dos seguintes motivos:',
		additionalRiskP1Latam:
			'Além das divulgações padrão do setor incluídas no Acordo de Conta do Cliente da Tradeview Markets, você deve estar ciente de que o trading de forex é considerado uma forma de investimento arriscada. Se você realizou apenas investimentos conservadores no passado, talvez queira estudar mais a fundo o trading de forex antes de continuar com um investimento desse tipo.',
		additionalRiskP2Latam:
			'Se você deseja continuar com seu investimento, reconhece que os fundos que você comprometeu são apenas capital de risco e a perda de seu investimento não comprometerá seu estilo de vida nem afetará seu futuro programa de aposentadoria. Além disso, você compreende totalmente a natureza e os riscos dos investimentos em forex, e suas obrigações para com os outros não serão negligenciadas caso você sofra perdas de investimento.',
		additionalRiskUl1: 'Você não tem entre 21 e 63 anos de idade',
		additionalRiskUl2: 'Sua renda anual é inferior a US$ 25.000',
		additionalRiskUl3: 'Você entrou com pedido de falência no último ano',
		additionalRiskUl4: 'Você não está empregado',
		additionalRiskD2:
			'Embora a Tradeview Financial Markets S.A.C. esteja preparada para abrir sua conta, é necessário aconselhá-lo a reconsiderar esse investimento. Com base em suas informações pessoais e/ou experiência de investimento, o forex pode ser uma estratégia de investimento muito arriscada. A perda na negociação de forex pode ser substancial. Portanto, você deve considerar cuidadosamente se essa negociação é adequada para você à luz de suas circunstâncias e recursos financeiros. O alto grau de alavancagem que pode ser obtido na negociação forex, devido às pequenas exigências de margem, pode funcionar tanto a seu favor quanto contra você. O uso de alavancagem pode levar a grandes perdas, bem como a ganhos.',
		additionalRiskChk1:
			'Entendo que não atendo às diretrizes mínimas para abrir uma conta, conforme estabelecido pela Tradeview Ltd. nos parágrafos acima. No entanto, considerei os riscos financeiros envolvidos na negociação forex com relação à minha situação pessoal e desejo prosseguir com a abertura de uma conta.',
		additionalRiskChk2:
			'Confirmo que li o texto acima e compreendo totalmente as informações aqui fornecidas.',
		additionalRiskChk1Latam:
			'Estou ciente dos riscos inerentes associados à minha conta de negociação e considerei todas as possíveis consequências da perda do meu investimento. Tendo lido os riscos associados ao trading de forex, estou disposto a prosseguir com o processo de abertura de conta.',
		additionalRiskChk2Latam:
			'Reconozco que he leído lo anterior y comprendo por completo la información proporcionada en este documento.',
		submitApplicationH: 'Enviar aplicativo',
		submitApplicationD1:
			'Você está quase lá! Agradecemos seu esforço em preencher sua inscrição. ',
		submitApplicationD2:
			'Quando estiver pronto, basta clicar no botão de envio abaixo para enviá-lo.',
		submitApplicationD3:
			'Se tiver alguma dúvida ou precisar de ajuda, não hesite em entrar em',
		submitApplicationLink: 'contato conosco.',
		submitApplicationCheck:
			'Concordo em ser incluído em nossa lista de distribuição de marketing',
		applicationSubmitedH: 'Solicitação enviada: revisão em andamento',
		applicationSubmitedD1:
			'Obrigado por enviar sua solicitação de conta. Sua solicitação está sendo analisada e será verificada em breve.',
		applicationSubmitedD2:
			'Nossa equipe de operações entrará em contato com você caso seja necessária alguma documentação adicional. ',
		applicationSubmitedD3:
			'Agradecemos sua cooperação e o manteremos atualizado sobre o progresso.',
		applicationSubmitedGT: 'Ir para o meu gabinete',
		applicationSubmitedET: 'Explorar o Tradeview',
		apEmailL: 'E-mail',
		apFirstNL: 'Seu primeiro nome',
		apFirstNP: 'Seu primeiro nome',
		apLastNL: 'Sobrenome',
		apLastNP: 'Sobrenome',
		apDateBL: 'Data de nascimento',
		apCountryBL: 'País de nascimento',
		apCountryBP: 'Selecione um país',
		apCountryNL: 'Nacionalidade',
		apCountryNP: 'Selecione uma nacionalidade',
		apMobileL: 'Celular (opcional)',
		apPhoneL: 'Telefone',
		apPassL: 'ID/Passaporte/SIN',
		apPassP: 'Digite seu documento de identidade, passaporte ou SIN',
		apPassT:
			'Você só precisa inserir um dos documentos de identificação. Lembre-se de que o SIN (Social Insurance Number, número de seguro social) só é necessário para usuários no Canadá.',
		apPassDL: 'Data de validade do ID/Passaporte/SIN',
		apGenderL: 'Gênero',
		apGenderP: 'Selecione uma opção',
		apMaritalL: 'Estado civil',
		apMaritalP: 'Selecione uma opção',
		apCountryRL: 'País de residência',
		apCountryRLResidence: 'País de Residência',
		apCountryRP: 'Selecione um país',
		apProvinceRL: 'Estado/Província',
		apProvinceRP: 'Selecione uma província',
		apCityRL: 'Cidade',
		apCityRP: 'Selecione uma cidade',
		apStreethRL: 'Nome da rua',
		apStreethRD: 'Digite o nome de sua rua',
		apStreethNL: 'Número da rua',
		apStreethND: 'Digite o número de sua rua',
		apPostCL: 'Código postal',
		apPostCD: 'Digite seu código postal',
		appAddresT:
			'Se o seu país de residência não estiver listado nas opções, lamentamos informar que não podemos oferecer nossos serviços em sua localidade',
		modalCompleteT: 'Todas as informações foram',
		modalCompleteT2: 'completadas!',
		modalCompleteP:
			'Temos todas as informações necessárias para concluir o processo. A última etapa é adicionar a assinatura do titular da conta e enviar a solicitação. Sua jornada está quase completa!',
		modalRegulationT: 'Você não pode continuar com',
		modalRegulationT2: 'sua inscrição',
		modalRegulationP:
			'Lamentamos. Devido à regulamentação, não podemos fornecer serviços a pessoas que residem no território dos EUA',
		modalRegulationP2: 'Obrigado por seu interesse em se juntar à Tradeview.',
		signatureTM2:
			'Certifique-se de que a assinatura seja igual à dos documentos enviados anteriormente. Os formatos de arquivo aceitos são: jpg, jpeg e png, com um tamanho máximo de arquivo de 2MB.',
		submitModal:
			'Detectamos alguns erros no formulário, revise e tente novamente ou, se o problema persistir, entre em contato com nossa equipe de suporte.',
		areaPH: 'Area',
		phonePH: 'Digite seu número de celular',
		emailPH: 'Digite seu e-mail',
		errorUpload: 'Carregue um arquivo em um formato e tamanho válidos.',
		apBtnContinue: 'Continuar',
		apBtnBack: 'Voltar',
		apBtnRegulation: 'Visite a página de regulamentação',
		complete: 'Preencher',
		pending: 'Pendente',
		rejected: 'Rejeitada',
		accepted: 'Aceitaram',
		enterFirstName: 'Digite um primeiro nome',
		enterLastName: 'Digite um sobrenome',
		enterAnEmail: 'Digite um e-mail',
		sendInvitation: 'Enviar convite',
		invitationSent: 'O convite foi enviado com sucesso!',
		invitationSentDesc:
			'Você pode acompanhar o progresso da solicitação na página de adição de titular secundário.',
		modifiedInvitation:
			'Informações do titular da conta secundária atualizadas com sucesso',
		modifiedInvitationDesc:
			'Um convite foi enviado para o endereço de e-mail que você forneceu para o titular da conta secundária. Você pode acompanhar o andamento da solicitação na página de adição do titular secundário.',
		notModifiedInvitation:
			'Informações do titular da conta secundária atualizadas com sucesso',
		notModifiedInvitationDesc:
			'Você pode acompanhar o progresso da solicitação na página de adição do titular secundário.',
		resend: 'Reenviar convite',
		saveShareholder: 'Salvar acionista',
		shareholderToComplete: 'Convidar acionista para terminar',
		companyDocuments: 'Verificação de documentos da empresa',
		companyDocumentsDesc:
			'Verifique sua conta, garantindo a conformidade e adaptando nossos serviços às suas necessidades comerciais.',
		documentUpload: 'Upload de documentos',
		documentUploadTooltip1:
			'Make sure the information and images in the file are clear and understandable.',
		documentUploadTooltip2:
			"Feel free to upload the documents you have at the moment. Don't worry if some are missing; you can upload or send them later upon request.",
		documentUploadDesc:
			'Selecione se deseja fazer upload de documentos agora ou salvar para depois. Se optar por fazer o upload agora, arraste e solte seus arquivos ou navegue pelas suas pastas',
		articlesIncorp: 'Artigos de incorporação',
		certificateIncorp: 'Certificado de incorporação',
		shareholderBreak: 'Composição dos acionistas',
		corporateBank: 'Extrato bancário da empresa',
		memorandumArticles: 'Memorando de associação/artigos de associação',
		uploadNow: 'Fazer upload agora?',
		imageType:
			'Certifique-se de que o arquivo esteja no formato JPEG, PNG ou PDF e que seu tamanho não exceda 2 MB.',
		sharesError:
			'A porcentagem combinada do acionista e do titular da conta não pode exceder 100%. Por favor, tente novamente.',
		inviteConfirmation: 'Pronto para enviar todos os seus convites?',
		inviteConfirmationDesc:
			'Um e-mail será enviado a todos os acionistas que você deseja adicionar à sua conta. Depois de enviado, você não poderá poderá adicionar mais acionistas.',
		inviteSent: 'Invitations have been sent successfully!',
		inviteSentDesc:
			'Você pode acompanhar o andamento da solicitação na página de adição do titular secundário.',
		deleteHolder: 'Tem certeza de que deseja excluir esse acionista?',
		deleteHolderDesc:
			'Você está prestes a eliminar um dos acionistas acionistas vinculados à sua conta corporativa. Deseja prosseguir?',
		unableToContinue: 'Não é possível continuar',
		unableToContinueDesc:
			'O endereço de e-mail fornecido já está associado a uma conta na Tradeview. Por favor, forneça outro e-mail para continuar.',
		provideAnother: 'Forneça outro endereço de e-mail',
		duplicated: 'Duplicado',
		duplicatedDesc:
			'O e-mail inserido já está associado a uma conta da Tradeview. Por favor, forneça outro e-mail para continuar.',
	},

	//validations yup app process
	yup: {
		selectOption: 'Por favor, selecione uma opção',
		phone: 'Seu número de telefone não pode ter letras ou símbolos.',
		phoneValid: 'Por favor use um número válido',
		dateofBirth: 'Digite sua data de nascimento',
		mustBeAdult:
			'Por favor, insira uma data de nascimento válida. Você deve ter mais de 18 anos para continuar.',
		passport: 'Digite seu número de identificação',
		passportValid: 'Por favor use um número válido',
		passportexpirationdate: 'Digite uma data válida',
		passportexpirationdateValid:
			'Digite uma data de validade válida. Somente documentos atuais são aceitos',
		streetname: 'Digite o nome de sua rua',
		streetnumber: 'Por favor, digite o número de sua rua',
		postcode: 'Por favor, digite seu código postal',
		taxReference:
			'Seu código de referência fiscal não pode conter espaços em branco ou símbolos. Tente novamente.',
		pepstatus: 'Por favor, insira as informações solicitadas',
		pepstatusValid: 'exceder o máximo de caracteres',
		employer: 'Digite o nome de seu empregador',
		occupation: 'Por favor, digite sua ocupação',
		employerAddress: 'Digite o endereço de seu empregador',
		employerpostalcode: 'Digite o CEP/código postal de seu empregador',
		businesstype: 'Digite seu tipo de negócio',
		industry: 'Informe o setor de sua empresa',
		business_location: 'Digite seu endereço comercial',
		business_name: 'Por favor, digite o nome de sua empresa',
		business_website: 'Por favor, Digite a url do site de sua empresa',
		bankruptciesdetails:
			'Por favor, escreva os detalhes de suas afiliações a falências.',
		acknowledgement:
			'Marque a caixa de seleção de confirmação para prosseguir.',
		agree: 'Marque a caixa de seleção de confirmação para prosseguir',
		expirationDate: 'Data de validade do passaporte inválida',
		invalidEmail: 'Formato de email inválido',
		EmailRequired: 'O e-mail é obrigatório',
		companyName: 'Por favor insira o nome da empresa controladorae',
		email: 'Por favor insira seu e-mail corporativol',
		businessDescription: 'Por favor, insira as informações solicitadas',
		required: 'Este campo é obrigatório',
		jobTitle: 'Por favor, insira seu título de trabalho',
		emailAlreadyRegistered:
			'O e-mail inserido já está registrado. Por favor, use um diferente.',
	},

	//helper arrays app proces
	array: {
		usd: 'USD: Dólar americano',
		eur: 'EUR: Euro',
		gbp: 'GBP: Libra da Grã-Bretanha',
		female: 'Feminino',
		male: 'Masculino',
		noBinary: 'Não binário',
		other: 'Outro gênero',
		noAnswer: 'Prefiro não responder',
		single: 'Solteiro',
		married: 'Casado',
		divorced: 'Divorciado',
		windowed: 'Viúvo',
		registered: 'Parceria registrada',
		yes: 'Sim',
		no: 'Não',
		employed: 'Empregado',
		selfEmployed: 'Autônomo',
		retired: 'Aposentado',
		unemployed: 'Desempregado',
		aerospaceAndDefense: 'Aeroespacial e Defesa',
		agriculture: 'Agricultura',
		automotive: 'Automotivo',
		construction: 'Construção civil',
		consulting: 'Consultoria',
		eCommerce: 'Comércio eletrônico',
		education: 'Educação',
		energyAndUtilities: 'Energia e serviços públicos',
		entertainmentAndMedia: 'Entretenimento e mídia',
		fashionAndApparel: 'Moda e vestuário',
		financeAndBanking: 'Finanças e bancos',
		foodAndBeverage: 'Alimentos e bebidas',
		government: 'Governo',
		healthAndWellness: 'Saúde e bem-estar',
		hospitality: 'Hospitalidade',
		itTechnology: 'TI/Tecnologia',
		legalServices: 'Serviços jurídicos',
		manufacturing: 'Manufatura',
		marketingAndAdvertising: 'Marketing e publicidade',
		nonProfitCharity: 'Sem fins lucrativos/caridade',
		realEstate: 'Imobiliário',
		retail: 'Varejo',
		benefitCorporation: 'Corporação de benefícios',
		cooperative: 'Cooperativa',
		cooperativeCorporation: 'Corporação Cooperativa',
		corporation: 'Corporação',
		familyOwnedBusiness: 'Empresa familiar',
		franchise: 'Franquia',
		holdingCompany: 'Empresa Holding',
		jointVenture: 'Joint Venture',
		llc: 'Sociedade de responsabilidade limitada (LLC)',
		lllp: 'Sociedade Limitada de Responsabilidade Limitada (LLLP)',
		llp: 'Sociedade de responsabilidade limitada (LLP)',
		lp: 'Sociedade Limitada (LP)',
		nonprofitOrganization: 'Organização sem fins lucrativos',
		partnership: 'Parceria',
		privateEquityFirm: 'Empresa de patrimônio privado',
		professionalCorporation: 'Corporação profissional (PC)',
		publiclyTradedCompany: 'Empresa de capital aberto',
		sCorporation: 'Corporação S',
		socialEnterprise: 'Empresa social',
		soleProprietorship: 'Empresa individual',
		serviceProvider: 'Provedor de serviços',
		telecommunications: 'Telecomunicações',
		transportationAndLogistics: 'Transporte e logística',
		apprenticeship: 'Aprendizagem',
		casual: 'Casual',
		contractual: 'Contractual',
		freelance: 'Freelancer',
		fullTime: 'Tempo integral',
		internship: 'Estágio',
		onDemand: 'Sob demanda',
		outsourcedOrOffshore: 'Terceirizado ou offshore',
		partTime: 'Meio período',
		permanent: 'Permanente',
		projectBased: 'Baseado em projetos',
		regular: 'Regular',
		seasonal: 'Sazonal',
		temporary: 'Temporário',
		volunteer: 'Voluntário',
		benefitCorporation: 'Corporação de benefícios (B Corp)',
		cooperative: 'Cooperativa',
		cooperativeCorporation: 'Corporação Cooperativa',
		corporation: 'Corporação',
		familyOwnedBusiness: 'Empresa familiar',
		franchise: 'Franquia',
		holdingCompany: 'Empresa Holding',
		jointVenture: 'Joint Venture',
		limitedLiabilityCompany: 'Sociedade de responsabilidade limitada (LLC)',
		limitedLiabilityLimitedPartnership:
			'Sociedade Limitada de Responsabilidade Limitada (LLLP)',
		limitedLiabilityPartnership: 'Sociedade de responsabilidade limitada (LLP)',
		limitedPartnership: 'Sociedade Limitada (LP)',
		nonprofitOrganization: 'Organização sem fins lucrativos',
		partnership: 'Parceria',
		privateEquityFirm: 'Empresa de patrimônio privado',
		professionalCorporation: 'Corporação profissional (PC)',
		publiclyTradedCompany: 'Empresa de capital aberto',
		sCorporation: 'Corporação S',
		socialEnterprise: 'Empresa social',
		soleProprietorship: 'Empresa individual',
		below25: 'Abaixo de US$ 25.000',
		between50: 'Entre US$ 25.000 e US$ 50.000',
		between100: 'Entre US$ 50.000 e US$ 100.000',
		over100: 'Mais de US$ 100.000',

		// CORPORATE
		below50mil: 'Menos de US$ 50.000',
		between100mil: 'Entre US$ 50.000 e US$ 100.000',
		between500mil: 'Entre US$ 100.000 e US$ 500.000',
		between1000mill: 'Entre US$ 500.000 e US$ 1.000.000',
		over1000mill: 'Mais de US$ 1.000.000',
		// END CORPORATE

		savingsFromSalary: 'Poupança do salário',
		governmentAid: 'Ajuda do governo',
		sale: 'Vendas',
		investmentsDividends: 'Investimentos, dividendos',
		incomeFromATrust: 'Renda de um fundo fiduciário',
		letting: 'Aluguel',
		inheritance: 'Herança',
		donation: 'Doação',
		loan: 'Empréstimo',
		incomeFromSelfEmployment: 'Renda de trabalho autônomo',
		parentsPartnerOrOther: 'Pais, parceiro ou outro',
		relativeSupport: 'Apoio de parentes',
		hedging: 'Hedging',
		speculation: 'Especulação',
		longTermInvesting: 'Investimento de longo prazo',
		proprietaryTrading: 'Negociação proprietária',
		drawSignature: 'Desenhar assinatura',
		uploadSignature: 'Carregar assinatura',
		neverTraded: 'Nunca negociei',
		zeroToFiveYears: '0 a 5 anos',
		sixToTenYears: '6-10 years',
		overTenYears: 'Mais de 10 anos',
		below50K: 'Abaixo de US$ 50.000',
		between50KTo100K: 'Entre US$ 50.000 e US$ 100.000',
		between100KTo500K: 'Entre US$ 100.000 e US$ 500.000',
		over500K: 'Mais de US$ 500.000,00',
		daily: 'Diariamente',
		weekly: 'Semanalmente',
		monthly: 'Mensalmente',
		quarterly: 'Trimestralmente',
		semiAnnually: 'Semestralmente',
		clientAgreement: 'Contrato do cliente',
		electronicTradingAgreement: 'Contrato de negociação eletrônica',
		riskDisclosure: 'Divulgação de riscos',
		privacyPolicy: 'Política de Privacidade',
		consentToDelivery:
			'Consentimento para entrega de extratos por mídia eletrônica',
		commissionAgreement: 'Contrato de comissão',
		termsAndConditions: 'Termos e condições',
		swapFreeAccount: 'Reconhecimento de Conta Livre de Swap',
		forex: 'Forex',
		stocks: 'Ações',
		futures: 'Futuros',
		months: {
			january: 'Janeiro',
			february: 'Fevereiro',
			march: 'Março',
			april: 'Abril',
			may: 'Maio',
			june: 'Junho',
			july: 'Julho',
			august: 'Agosto',
			september: 'Setembro',
			october: 'Outubro',
			november: 'Novembro',
			december: 'Dezembro',
		},
		passport: 'Passaporte',
		identityCard: 'Carteira de identidade',
		residencePermit: 'Autorização de residência',
		driversLicense: 'Carteira de motorista',
		utilityBill: 'Conta de serviços públicos',
		bankStatement: 'Extrato bancário',
		certificateResidency: 'Certificado de residência',
		today: 'Hoje',
		lastWeek: 'Última semana',
		lastMonth: 'Último mês',
		last3Months: 'Últimos 3 meses',
		last6Months: 'Últimos 6 meses',
		costumPeriod: 'Período de custo',
		lastQuarter: 'Ultimo quarto',
		lastSemester: 'Semestre passado',
		lastYear: 'Ano passado',
		step: 'Etapa',
		sell: 'Vender',
		buy: 'Comprar',
		transfer: 'Transferir',
		deposit: 'Depositar',
		withdrawal: 'Saque',
		payout: 'Pagamento',
		adjustment: 'Ajuste',
		live: 'Real',
		demo: 'Demo',
	},
	//MFA
	mfa: {
		body: 'Além de sua senha, configure um método de verificação secundário para manter sua conta ainda mais segura.',
		text: 'Ao ativar a autenticação em duas etapas, você precisará digitar sua senha e um código de verificação enviado ao seu endereço de e-mail.',
		turn: 'Turn',
		on: 'Ligado',
		off: 'Desligado',
		confirm: 'Confirmar',
		textTwo: 'Tem certeza de que deseja desativar a MFA?',
		yes: 'Sim',
		no: 'Não',
	},

	progress: {
		title: 'Progresso do aplicativo',
		progress1: 'Detalhes pessoais',
		progress2: 'Residência fiscal',
		progress3: 'Plataforma e moeda',
		progress31: 'Configuração da conta',
		progress4: 'Detalhes do emprego',
		progress5: 'Dados financeiros',
		progress6: 'Experiência',
		progress7: 'Tipo de identificação',
		progress8: 'Comprovante de residência',
		progress9: 'Reconhecimento',
		progress91: 'Consentimento e Envio',
		progress10: 'Assinatura',
		progress11: 'Divulgação de riscos adicionais',
		progress12: 'Enviar aplicativo',
		progress121: 'Submissão',
		progress13: 'Titular secundário da conta',
		progress131: 'Adição de titular secundário',
	},

	btns_: {
		back: 'Voltar',
		continue: 'Continuar',
		cancel: 'Cancelar',
		yesDelete: 'Sim, excluir',
		noDelete: 'Não, voltar',
		resendInvitations: 'Reenviar convites',
		of: 'de',
		yesImSure: 'Sim eu tenho certeza',
		submit: 'Enviar',
	},
	trading_tools: {
		main_title: 'Suas ferramentas de trading',
		main_desc:
			'Tome decisões mais inteligentes e baseadas em dados com nossas poderosas ferramentas de trading, projetadas para te dar vantagem no mercado.',
		calculatorSuite: 'Conjunto de calculadoras',
		calculatorSuiteDesc:
			'Prepare-se com todas as ferramentas essenciais para o trading estratégico! Este poderoso kit é projetado para capacitar você e desvendar seu potencial, independentemente do seu nível de trading.',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'Acesse recursos gratuitos e focados no crescimento, como chat ao vivo com traders e especialistas, transmissões ao vivo e notícias do mercado em tempo real para navegar nos mercados com confiança.',
		surfsup: 'Surf’s Up!',
		surfsupDesc:
			'Mantenha-se atualizado sobre os últimos desenvolvimentos do mercado e explore novas estratégias, insights e análises.',
	},
}
